<template>
  <div class="overall-bg pb-0">
    <b-container>
      <b-row>
        <b-col>
          <BackBtn v-if="IsGRNApproval.IsApproval == 0" :goback="$router.back" />
          <Headerlayout :headertext="paramValue"></Headerlayout>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <div class="overall-bg pt-1">
    <b-container>
      <!-- <b-form @submit.prevent="IsSubmitFunc(0)"> -->
      <b-row class="stepperdiv" :class="{ 'scrolled': isScrolled }">
        <b-col lg="8" md="8" sm="8" cols="10">
          <div class="stepslist">
            <div v-for="(step, index) in stepslist" :key="index"
              :class="['singlestep', { active: currentStep === index }]" @click="goToStep(index)">
              <span>{{ step.value }}</span>
              <span>{{ step.label }}</span>

            </div>
          </div>
        </b-col>
        <b-col lg="4" md="4" sm="4" cols="2"
          v-if="items.length != 0 && IsGRNApproval.IsApproval == 0 && (!($route.query.IsDraft == 0 && currentStep == 0))"
          class="d-flex flex-row-reverse">
          <!-- <Footer :cancelhide="false" /> -->
          <div class="poaction">
            <div class="savedraftbtn me-2 " v-if="!tabMove">
              <span v-if="loading">Loading...</span>
              <p v-else @click="IsSubmitFunc(1)">Save as draft</p>
            </div>
            <Footer label="Save" :cancelhide="false" :loading="loading" @save="IsSubmitFunc(0)" />
            <!-- <AddButton btnname="Save" type="submit" :loading="loading" /> -->
          </div>
        </b-col>


      </b-row>
      <div class="row form-white-bg">
        <div class="steppercontent">
          <div v-if="currentStep == 0">
            <b-row>
              <b-col lg="2" class="field">
                <label>{{
                  paramnames == "DC" ? $t("grn.dcno") : $t("grn.grnno")
                }}</label>
                <GetCode label="GRN NO." name="GRN NO." :FormId="Entitydata" v-model="requestForm.DocNo" />
              </b-col>
              <b-col lg="2" class="field" v-if="paramnames == 'DC'">
                <CustomDropdown :required-icon="true" :label="$t('grn.dctype')" :rules="{ required: true }"
                  name="DC Type" id="DC Type" v-model="requestForm.DCType" :items="DCTypeOption" @change="DCChange"
                  :disabled="(false) || (EditId)" />
              </b-col>
              <PoSupplierInvoiceComponent v-model="PurchaseformData" :showone="paramValue"
                :commonItemProps="commonProps" @getPoItems="getPoItems" :POId="RefIdByMas" :supplierDeatails="itemDatas"
                :cardshow="false" @update:modelValue="SupplierValue" :value="PurchaseformData"
                :disabled="SupplierDropDownDisable" :SelectedDCType="SelectedDCType" @DCNoDropdownLength="DCNoDropdown"
                :IsGRNApproval="IsGRNApproval" />
              <b-col lg="2" class="field" v-if="requestForm.DCType == 2 && paramnames == 'DC'">
                <label>{{ $t("grn.grnreturncode") }}</label>

                <AutoCompleteCustom name="GRN Return" label="GRN Return" id="GRN Return" v-model="DataObj.ReturnId"
                  :required-icon="true" :rules="{ required: true, alphanumeric: true }" :items="DataObj.ReturnOptions"
                  @item-select="GetByGrn" @input="LoadGRNReturn()" />
              </b-col>

            </b-row>
            <b-row>
              <b-col lg="6" md="8" sm="6">
                <Invoice :showone="paramValue" v-model="invDetails" :value="invDetails"
                  :invoicedisable="requestForm.IsDraft == 1 ? false : EditId" />
                <!-- :invoicedisable="(false ) || (EditId)" -->
              </b-col>
              <b-col lg="6" md="4" sm="6" cols="12" class="d-flex">
                <div class="field">
                  <label>{{ $t("Request.uploadquotation") }}</label>
                  <input type="file" :multiple="true" id="actual-btn" @change="handleChangedocument" ref="fileInput"
                    style="display: none;" />
                  <label id="custom-btn" for="actual-btn" class="flbtn">
                    <i class="pi pi-upload" style="color: slateblue"></i>
                    Choose File</label>
                </div>
              </b-col>
              <b-row>
                <b-col lg="3" md="4" sm="6" cols="12" class="d-flex" v-for="item in uploadedTableList">
                  <div class="fileuploadcard my-2" :title="item.fileName">
                    <div>
                      <p class="filenametxt">{{ item.fileName }}</p>
                      <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                        view </div>
                    </div>
                    <DeleteIcon @click="fileuploadDelete(item)" />
                  </div>
                </b-col>
              </b-row>
            </b-row>
            <!-- <b-row
                v-if="(paramnames == 'GRN With PO' || paramnames == 'GRN Without PO' || (requestForm.DCType != 2 && paramnames == 'DC')) && requestForm.DCType != 3 && ((paramnames == 'DC' && (DCNoDropdownLength == 0 || DCNoDropdownLength > 0)) || paramnames == 'GRN Without PO' && DCNoDropdownLength == 0)"> -->
            <b-row
              v-if="paramnames == 'GRN With PO' || paramnames == 'GRN Without PO' || ((paramnames == 'GRN With PO' || (requestForm.DCType != 2 && paramnames == 'DC')) && requestForm.DCType != 3 && (paramnames == 'DC' && (DCNoDropdownLength == 0 || DCNoDropdownLength > 0)))">
              <b-col class="item-toggle">
                <p v-if="!EditId || requestForm.IsDraft == 1" v-b-toggle.collapse-3 variant="primary" class="link-txt">
                  <span class="when-open">Close</span><span class="when-closed"> <i class="pi pi-plus me-2"
                      style="font-size: 11px"></i>Add
                    Item</span>
                </p>
                <b-collapse id="collapse-3" :class="displayClass">
                  <ItemView @additemclick="AddItems" v-model:data-items="dataItems" :show-fields="showFields"
                    :addItemData="items" @calculation="TotalGrossCalc" :commonItemProps="commonItemProps"
                    :isFilterData="itemDatas" @taxcalculation="taxCalculation" :nonFilterData="nonFilterDatas"
                    @ExcelData="ExcelDataImport" @clearitem="clearItems" :SelectedDCType="SelectedDCType" />
                </b-collapse>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="grnitemstabs">

                <b-tabs pills v-model="activetab">
                  <b-tab
                    v-if="((paramnames == 'DC' && (requestForm.DCType == '2' || requestForm.DCType == '3')) || (paramnames != 'GRN Without PO' && paramnames != 'DC')) && (!EditId || requestForm.IsDraft == 1)"
                    :active="TabsActive.AllItem" @click="TabClick(1)">
                    <template #title>
                      <div class="d-flex align-items-center">
                        <span class="me-2">All Items</span>
                        <span>
                          <OrangeBadge :BadgeValue="recieveditems.length" />
                        </span>
                      </div>
                    </template>
                    <div class="position-relative">
                      <!-- {{ recieveditems }} -->
                      <OverallItemList :propsitems="recieveditems" @selectedItem="AddselectedItem"
                        @AddSelectItems="AddAllItem" v-model:selectedList="SelectList" @FilterPOItems="FilterByCategory"
                        :itemcatfilteroptions="itemcatfilteroptions" :requestForm="requestForm"
                        @amountCalc="AmountCalculation" :receivedList="items" :DCNoDropdownLength="DCNoDropdownLength"
                        :paramnames="paramValue" :DCType="requestForm.DCType" @GRNCalculation="GRNCalculation"
                        :receivedtabflag="receivedtabflag" />

                    </div>
                  </b-tab>

                  <b-tab :active="TabsActive.ReceivedItems" @click="TabClick(2)">
                    <template #title>
                      <div class="d-flex align-items-center">
                        <span class="me-2">Received</span>
                        <span>
                          <OrangeBadge :BadgeValue="items.length" />
                        </span>
                      </div>
                    </template>
                    <div class="mt-3 position-relative">
                      <button class="btn btn-primary summary-button" @click="showSummaryPopup = true">
                        <i class="pi pi-list me-1"></i>Summary
                      </button>
                      <!-- {{ items }} -->
                      <Table :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="headers"
                        v-model:value="items" :seriaNlumber="true" @updatedata="Itemschanges">
                        <template v-slot:combinedFieldSlot="{ data, rowIndex }">
                          <span>
                            <template v-if="data.BrandName">{{ data.BrandName }}</template>
                            <template v-if="data.BrandName && data.ModelNumberName">/</template>
                            <template v-if="data.ModelNumberName">{{ data.ModelNumberName }}</template>
                            <template v-if="(data.BrandName || data.ModelNumberName) && data.SizeName">/</template>
                            <template v-if="data.SizeName">{{ data.SizeName }}</template>
                          </span>
                        </template>

                        <template v-slot:Add>
                          <span>
                            <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                          </span>
                        </template>
                        <template v-slot:action="{ data, rowIndex }" v-if="!EditId || requestForm.IsDraft == 1">
                          <div v-if="data.IsConsigneeItem == 1 ? false : true" class="d-flex align-items-center">
                            <!-- <EditIcon @click="IsItemEdit(data)" v-if="paramnames == 'GRN Without PO'" /> -->
                            <EditIcon @click="IsItemEdit(data)"
                              v-if="paramnames == 'GRN Without PO' && data.DocType != 19 || (paramnames == 'DC' && SelectedDCType != 3)" />

                            <!-- v-if="paramnames == 'GRN Without PO' && data.DocType != 19" /> -->
                            <DeleteIcon @click="ItemDeleteConfirm($event, data)" />
                          </div>
                        </template>
                        <template v-slot:Itemname1="{ data, rowIndex }">
                          <div v-if="data.ColdChain">
                            <span :style="getColorStyle(data)">
                              {{ data.Itemname1 }}-({{ data.ColdChain }})
                            </span>
                          </div>
                          <div v-if="data.IsFreeItem == '1'">
                            <span :style="getPromoColorStyle(data)">
                              {{ data.Itemname1 }} - (Promo)
                            </span>
                          </div>
                          <div v-else-if="data.IsFreeQtyItem == '1'">
                            <span :style="getFreeQtyColorStyle(data)">
                              {{ data.Itemname1 }} - (Free)
                            </span>
                          </div>

                          <p v-else>
                            {{ data.Itemname1 }}
                          </p>
                        </template>
                        <template v-slot:Qty="{ data, rowIndex }">

                          <div class="label-d-none tablefield mb-0">
                            <InputText placeholder="" clearable
                              :name="`'Qty'${data.ItemId}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.BatchNo}${data.ItemQuantity}`"
                              :id="`'Qty'${data.ItemId}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.BatchNo}${data.ItemQuantity}`"
                              @keyup="ItemQtyOnChange(data)" label="" v-model="data.ItemQuantity"
                              :rules="{ numeric: true }"
                              :disabled="((data.IsConsigneeItem == 1) || (data.DCType == 1 && data.StockoutId != 0 && data.StockOutDetailId != 0) ? true : false) || (EditId && data.IsDraft != 1 && IsGRNApproval.IsApproval != 1)" />
                          </div>
                        </template>

                        <template v-slot:MRPSlot="{ data, rowIndex }">
                          <div class="label-d-none tablefield mb-0">
                            <TextField placeholder="" clearable
                              :name="`'MRP'${data.ItemId}${data.MRP}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.BatchNo}`"
                              :id="`'MRP'${data.ItemId}${data.MRP}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.BatchNo}`"
                              label="" v-model="data.MRP"
                              :rules="{ decimal: false, nonzeroable: ($route.query.IsZeroBill == 'true' || paramnames == 'DC') ? false : true }"
                              :disabled="(data.IsConsigneeItem == 1 ? true : false) || (EditId && data.IsDraft != 1 && IsGRNApproval.IsApproval != 1)" />
                          </div>
                        </template>
                        <template v-slot:UnitRateSlot="{ data, rowIndex }">
                          <div class="label-d-none tablefield mb-0">
                            <div v-if="paramnames == 'GRN Without PO' && data.DocType == 19">
                              <TextField placeholder="" clearable
                                :name="`UnitRate${data.ItemId}${data.UnitRate}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.BatchNo}`"
                                :id="`UnitRate${data.ItemId}${data.UnitRate}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.BatchNo}`"
                                @keyup="ItemUnitRateOnChange(data)" label="" v-model="data.UnitRate"
                                :rules="{ decimal: true, nonzeroable: ($route.query.IsZeroBill === 'true') }"
                                :disabled="data.IsConsigneeItem === 1 || (EditId && data.IsDraft !== 1 && IsGRNApproval.IsApproval !== 1)" />
                            </div>
                            <div v-else>
                              {{ data.UnitRate }}
                            </div>
                          </div>
                        </template>

                        <template v-slot:FreeQty="{ data, rowIndex }">
                          <div class="label-d-none tablefield mb-0">
                            <TextField placeholder="" clearable
                              :name="`'FreeQty'${data.ItemId}${data.FreeQty}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.BatchNo}${data.IsFreeItem}${data.IsFreeQtyItem}`"
                              :id="`'FreeQty'${data.ItemId}${data.FreeQty}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.BatchNo}${data.IsFreeItem}${data.IsFreeQtyItem}`"
                              label="" v-model="data.FreeQty" :rules="{ numeric: true }"
                              :disabled="((data.IsConsigneeItem == 1) || (data.IsFreeQtyItem == 1) || (data.DCType == 1 && data.StockoutId != 0 && data.StockOutDetailId != 0) ? true : false) || (EditId && data.IsDraft != 1 && IsGRNApproval.IsApproval != 1) || (paramnames == 'GRN Without PO' && DCNoDropdownLength != 0 && data.DCType == 4) || (paramnames == 'GRN With PO' && DCNoDropdownLength != 0 && data.DCType == 3)" />
                          </div>
                        </template>

                        <!-- <template v-slot:transportcharges="{ data, rowIndex }">
                            <TextField placeholder="" clearable
                              :name="`'transportcharges'${data.ItemId}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                              :id="`'transportcharges'${data.ItemId}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                              @keyup="AmountCalculation(data, items, 0), taxCalculation(items)" label=""
                              v-model="data.transportcharges" :rules="{ required: false, decimal: true }"
                              :requiredIcon="false" :disabled="data.IsConsigneeItem == 1 ? true : false" />
                          </template> -->

                        <template v-slot:Discount="{ data, }">
                          <div class="label-d-none tablefield mb-0">
                            <TextField placeholder="" clearable
                              :name="`'Discount'${data.ItemId}${data.BatchNo}${data.Discount}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.rowIndex}`"
                              :id="`'Discount'${data.ItemId}${data.BatchNo}${data.Discount}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.rowIndex}`"
                              @keyup="ItemDiscountAmountCalculation(data)" label="" v-model="data.Discount"
                              :rules="{ required: false, decimal: true, percentage: true }" :requiredIcon="false"
                              :disabled="((data.IsConsigneeItem == 1) || (data.IsFreeItem == 1) || (data.DCType == 1 && data.StockoutId != 0 && data.StockOutDetailId != 0) ? true : false) || (EditId && data.IsDraft != 1 && IsGRNApproval.IsApproval != 1) || (paramnames == 'GRN Without PO' && DCNoDropdownLength != 0 && data.DCType == 4) || (paramnames == 'GRN With PO' && DCNoDropdownLength != 0 && data.DCType == 3)" />
                          </div>
                        </template>
                        <template v-slot:DiscountAmount="{ data, rowIndex }">

                          <div class="label-d-none tablefield mb-0">
                            <TextField placeholder="" clearable
                              :name="`'DiscountAmount'${data.ItemId}${data.BatchNo}${data.Discountamount}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.rowIndex}`"
                              :id="`'DiscountAmount'${data.ItemId}${data.BatchNo}${data.Discountamount}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.rowIndex}`"
                              @keyup="ItemDiscountPercentageCalculation(data)" label="" v-model="data.Discountamount"
                              :rules="{ required: false, decimal: true }" :requiredIcon="false"
                              :disabled="((data.IsConsigneeItem == 1) || (data.IsFreeItem == 1) || (data.DCType == 1 && data.StockoutId != 0 && data.StockOutDetailId != 0) ? true : false) || (EditId && data.IsDraft != 1 && IsGRNApproval.IsApproval != 1) || (paramnames == 'GRN Without PO' && DCNoDropdownLength != 0 && data.DCType == 4) || (paramnames == 'GRN With PO' && DCNoDropdownLength != 0 && data.DCType == 3)" />
                          </div>

                        </template>
                        <template v-slot:servicecharges="{ data, rowIndex }">

                          <div class="label-d-none tablefield mb-0">
                            <TextField placeholder="" clearable
                              :name="`'servicecharges'${data.ItemId}${data.BatchNo}${data.servicecharges}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                              :id="`'servicecharges'${data.ItemId}${data.BatchNo}${data.servicecharges}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                              @keyup="
                                ItemServiceChargesOnChange(data)
                                " label="" v-model="data.servicecharges" :rules="{ required: false, decimal: true }"
                              :requiredIcon="false"
                              :disabled="(false) || (data.IsFreeItem == 1) || (EditId && data.IsDraft != 1 && IsGRNApproval.IsApproval != 1) || (paramnames == 'GRN Without PO' && DCNoDropdownLength != 0 && data.DCType == 4) || (paramnames == 'GRN With PO' && DCNoDropdownLength != 0 && data.DCType == 3) || (data.DCType == 1 && data.StockoutId != 0 && data.StockOutDetailId != 0)" />
                          </div>
                        </template>
                        <template v-slot:othercharges="{ data, rowIndex }">

                          <div class="label-d-none tablefield mb-0">
                            <TextField type="text" placeholder="" clearable
                              :name="`'othercharges'${data.ItemId}${data.BatchNo}${data.othercharges}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                              :id="`'othercharges'${data.ItemId}${data.BatchNo}${data.othercharges}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                              @keyup="
                                ItemOtherChargesOnChange(data)
                                " label="" v-model="data.othercharges" :rules="{ required: false, decimal: true }"
                              :requiredIcon="false"
                              :disabled="(false) || (data.IsFreeItem == 1) || (EditId && data.IsDraft != 1 && IsGRNApproval.IsApproval != 1) || (paramnames == 'GRN Without PO' && DCNoDropdownLength != 0 && data.DCType == 4) || (paramnames == 'GRN With PO' && DCNoDropdownLength != 0 && data.DCType == 3) || (data.DCType == 1 && data.StockoutId != 0 && data.StockOutDetailId != 0)" />
                          </div>
                          <!-- :disabled="(false) || (EditId && data.IsDraft != 1) || (paramnames == 'GRN Without PO' && DCNoDropdownLength != 0 && data.DCType == 4) || (paramnames == 'GRN With PO' && DCNoDropdownLength != 0 && data.DCType == 3) || (data.DCType == 1 && data.StockoutId != 0 && data.StockOutDetailId != 0)" /> -->

                        </template>

                        <template v-slot:BatchNo="{ data, rowIndex }">
                          <!-- <p v-if="requestForm.DocType == '7'">
                              {{ data.BatchNo }}
                            </p> -->
                          <!-- <div class="label-d-none tablefield mb-0" v-else> -->
                          <div class="label-d-none tablefield mb-0">
                            <InputText :title="data.BatchNo"
                              :name="`'BatchNo'${data.ItemId}${data.BatchNo}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                              :id="`'BatchNo'${data.ItemId}${data.BatchNo}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                              v-if="data.BatchRequired" type="text" placeholder="" clearable @keyup="AmountCalculation(data, items, 0), taxCalculation(items)
                                " label="" v-model="data.BatchNo" :rules="{ required: false }" :requiredIcon="false"
                              :disabled="(false) || (EditId && data.IsDraft != 1 && IsGRNApproval.IsApproval != 1) || (paramnames == 'GRN Without PO' && DCNoDropdownLength != 0 && data.DCType == 4) || (paramnames == 'GRN With PO' && DCNoDropdownLength != 0 && data.DCType == 3) || (data.DCType == 1 && data.StockoutId != 0 && data.StockOutDetailId != 0)" />
                          </div>

                        </template>

                        <template v-slot:SupplierBarCode="{ data, rowIndex }">
                          <div class="label-d-none tablefield mb-0">
                            <TextField type="text" placeholder="" clearable
                              :name="`'SupplierBarCode'${data.ItemId}${data.SupplierBarCode}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                              :id="`'SupplierBarCode'${data.ItemId}${data.SupplierBarCode}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                              label="" v-model="data.SupplierBarCode" :rules="{ required: false }" :requiredIcon="false"
                              :disabled="(false) || (EditId && data.IsDraft != 1) || (paramnames == 'GRN Without PO' && DCNoDropdownLength != 0 && data.DCType == 4) || (paramnames == 'GRN With PO' && DCNoDropdownLength != 0 && data.DCType == 3) || (data.DCType == 1 && data.StockoutId != 0 && data.StockOutDetailId != 0)" />
                          </div>
                        </template>
                        <template v-slot:ExpiryDate="{ data, rowIndex }">
                          <div class="label-d-none tablefield mb-0" v-if="data.ExpiryDtRequired == true">
                            <div v-if="requestForm.DocType == '7' || requestForm.DocType == '19'">
                              <p
                                v-if="(false) || (EditId && IsGRNApproval.IsApproval != 1) || (data.IsFreeItem == 1) || (data.IsFreeQtyItem == 1) || (requestForm.DCType == 1 || requestForm.DCType == 2 || requestForm.DCType == 4 && requestForm.DocType == '19')">
                                {{ data.ExpiryDate }}</p>
                              <Datepicker v-else v-model="data.ExpiryDate1" :value="data.ExpiryDate1"
                                :name="`'ExpiryDate'${data.ItemId}${data.BatchNo}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.rowIndex}`"
                                :id="`'ExpiryDate'${data.ItemId}${data.BatchNo}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.rowIndex}`"
                                :disabled="(false) || (EditId && data.IsDraft != 1 && IsGRNApproval.IsApproval != 1) || (paramnames == 'GRN Without PO' && DCNoDropdownLength != 0 && data.DCType == 4) || (paramnames == 'GRN With PO' && DCNoDropdownLength != 0 && data.DCType == 3) || (data.DCType == 1 && data.StockoutId != 0 && data.StockOutDetailId != 0)"
                                :minDate="minExpiryDate" />
                            </div>
                            <p v-else>
                              {{ data.ExpiryDate }}
                            </p>
                          </div>

                        </template>
                        <template v-slot:ManufactureDate="{ data, rowIndex }">
                          <div class="label-d-none tablefield mb-0" v-if="data.ManufactureDtRequired == true">
                            <!-- v-if="data.ManufactureDtRequired == true" -->
                            <!-- <div
                                v-if="requestForm.DocType == '7' || requestForm.DocType == '19' || (requestForm.DocType != '19' && data.ManufactureDtRequired == true)"> -->
                            <!-- <div
                                v-if="requestForm.DocType == '7' || requestForm.DocType == '19' || (requestForm.DocType != '19')"> -->
                            <div v-if="requestForm.DocType == '7' || requestForm.DocType == '19'">
                              <p
                                v-if="(false) || (EditId) || (data.IsFreeItem == 1) || (data.IsFreeQtyItem == 1) || (requestForm.DCType == 4 && requestForm.DocType == '19')">
                                {{ data.ManufactureDate }}</p>
                              <Datepicker v-else v-model="data.ManufactureDt" :value="data.ManufactureDt"
                                :name="`'ManufactureDt'${data.ItemId}${data.BatchNo}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.rowIndex}`"
                                :id="`'ManufactureDt'${data.ItemId}${data.BatchNo}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.rowIndex}`"
                                :disabled="(false) || (EditId && data.IsDraft != 1) || (paramnames == 'GRN Without PO' && DCNoDropdownLength != 0 && data.DCType == 4) || (paramnames == 'GRN With PO' && DCNoDropdownLength != 0 && data.DCType == 3) || (data.DCType == 1 && data.StockoutId != 0 && data.StockOutDetailId != 0)"
                                :maxDate="maxDate" />
                            </div>
                            <p v-else>
                              {{ data.ManufactureDate }}
                            </p>
                          </div>

                        </template>
                      </Table>
                    </div>

                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
            <b-row>

              <b-col>
                <div class="field">
                  <!-- {{requestForm.GRNTransportationCharges}} -->
                  <TextField name="Transportation Charges" :label="$t('grn.transportationcharges')"
                    :rules="{ required: false, decimal: true }" id="Transportation Charges"
                    v-model="requestForm.GRNTransportationCharges" @keyup="TransportAmountOnChange"
                    :disabled="SupplierDropDownDisable" />
                </div>

              </b-col>
              <b-col>
                <div class="field">
                  <TextField name="Transportation Tax" :label="$t('grn.transportationtax')"
                    :rules="{ required: false, decimal: true, percentage: true }" id="Transportation Tax"
                    v-model="requestForm.GRNTransportationTax" @keyup="TransportTaxOnChange"
                    :disabled="SupplierDropDownDisable" />
                </div>
              </b-col>

              <b-col>
                <div class="field">
                  <TextField name="Freight Charges" :label="$t('grn.freightcharges')"
                    :rules="{ required: false, decimal: true }" id="Freight Charges"
                    v-model="requestForm.GRNFreightCharges" @keyup="FreightAmountOnChange"
                    :disabled="SupplierDropDownDisable" />
                </div>
              </b-col>
              <b-col>
                <div class="field">
                  <TextField name="Freight Tax" :label="$t('grn.freighttax')"
                    :rules="{ required: false, decimal: true, percentage: true }" id="Transportation Tax"
                    v-model="requestForm.GRNFreightTax" @keyup="FreightTaxOnChange"
                    :disabled="SupplierDropDownDisable" />
                </div>
              </b-col>

              <b-col>
                <div class="field">
                  <TextField name="Other Charges" :label="$t('grn.othercharges')"
                    :rules="{ required: false, decimal: true }" id="Other Charges" v-model="requestForm.GRNOtherCharges"
                    @keyup="OverallOtherChargesOnChange" :disabled="SupplierDropDownDisable" />
                </div>
              </b-col>
              <b-col>
                <div class="field">
                  <TextField name="Discount" :label="$t('grn.discountamount')"
                    :rules="{ required: false, decimal: true }" id="Discount" v-model="requestForm.GRNDiscount"
                    @keyup="OverAllDiscountAmountOnChange" :disabled="SupplierDropDownDisable" />
                </div>
              </b-col>
              <b-col>
                <div class="field">
                  <TextField name="Roundoff" :label="$t('grn.roundoff')" v-model="requestForm.RoundOff"
                    :rules="{ required: false, alphabet: false }" id="Roundoff" @keyup="RoundOffOnChange"
                    :disabled="RoundOffDisable" />
                </div>
              </b-col>
            </b-row>
            <b-row class="form-white-bg pt-0">
              <b-col class="footer-sec-table" lg="8" md="8" sm="12" cols="12">
                <FooterSectionTable :item-data="taxvalues" :normaltablesearch="normaltablesearch" />

              </b-col>
              <b-col lg="4" md="4" sm="12" cols="12">
                <!-- <FooterSection v-model="grossvalues" :grossvalue="grossvalues" :flagval="true" /> -->
                <b-row class="mt-1">

                  <b-col lg="12" md="12">
                    <b-row>
                      <b-col class="ammount_footer">
                        <p class="light-txt">
                          Gross Amount
                        </p>
                        <p>
                          <span class="pe-1">&#8377</span>
                          {{ grossvalues.grossamount }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col class="ammount_footer">
                        <p class="light-txt">
                          Discount Amount
                        </p>
                        <p>
                          <span class="pe-1">&#8377</span>
                          {{ grossvalues.totaldiscountamount }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col class="ammount_footer">
                        <p class="light-txt">
                          Tax Amount
                        </p>
                        <p>
                          <span class="pe-1">&#8377</span>
                          {{ grossvalues.taxamount }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col class="ammount_footer">
                        <p class="light-txt">
                          SGST Amount
                        </p>
                        <p>
                          <span class="pe-1">&#8377</span>
                          {{ grossvalues.sgsttaxamount }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col class="ammount_footer">
                        <p class="light-txt">
                          CGST Amount
                        </p>
                        <p>
                          <span class="pe-1">&#8377</span>
                          {{ grossvalues.cgsttaxamount }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col class="ammount_footer">
                        <p class="light-txt">
                          IGST Amount
                        </p>
                        <p>
                          <span class="pe-1">&#8377</span>
                          {{ grossvalues.igsttaxamount }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col class="ammount_footer">
                        <p class="light-txt">
                          Transport charges
                        </p>
                        <p>
                          <span class="pe-1">&#8377</span>
                          {{ grossvalues.transportcharges }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col class="ammount_footer">
                        <p class="light-txt">
                          Freight charges
                        </p>
                        <p>
                          <span class="pe-1">&#8377</span>
                          {{ grossvalues.freightcharges }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col class="ammount_footer">
                        <p class="light-txt">
                          Service Charges
                        </p>
                        <p>
                          <span class="pe-1">&#8377</span>
                          {{ grossvalues.servicecharges }}
                        </p>
                      </b-col>
                    </b-row>


                    <b-row>
                      <b-col class="ammount_footer">
                        <p class="light-txt">
                          Other charges
                        </p>
                        <p>
                          <span class="pe-1">&#8377</span>
                          {{ grossvalues.othercharges }}
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col class="d-flex align-items-center mt-5">
                        <p>
                          Grand Total
                        </p>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col offset-lg="3" class="d-flex px-0">
                        <div class="totaldiv1">
                          <p class="component-heading">{{ grossvalues.totalqty }}</p>

                          <p class="light-txt">Items Part of this GRN</p>
                        </div>
                        <div class="totaldiv2">
                          <p class="component-heading"><span class="pe-1">&#8377</span>{{
                            grossvalues.netamount }}
                          </p>
                          <p class="light-txt mt-3">{{ $t('grn.value') }}</p>
                        </div>
                      </b-col>
                    </b-row>

                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <div v-if="currentStep == 1">
            <ItemAllocatedTable :GRNId="EditId" @BarCodeItem="AddItemAllocation" />
          </div>
        </div>
      </div>

      <!-- </b-form> -->
    </b-container>

    <Toast />
    <ConfirmPopup />

    <CreateSuccessully :visible="popup.successpop" @ok="closetrigger()" />
    <UpdatedSuccessfully :visible="popup.updatepop" @ok="closetrigger()" />
    <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues"
      :PrintType="PrintType" />

    <!-- Summary Popup -->
    <Dialog header="Items Summary" v-model:visible="showSummaryPopup" :closable="false"
      :breakpoints="{ '960px': '75vw', '641px': '85vw', '500px': '90vw' }" :style="{ width: '50vw' }" :modal="true">
      <template #header>
        <b-container fluid>
          <b-row>
            <b-col>
              <h4 class="m-0">Items Summary</h4>
            </b-col>
            <b-col class="d-flex flex-row-reverse">
              <i class="pi pi-times" @click="showSummaryPopup = false" style="cursor: pointer;" />
            </b-col>
          </b-row>
        </b-container>
      </template>
      <div class="summary-content">
        <Table :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="summaryHeaders"
          v-model:value="summarizedItems" :seriaNlumber="true">
        </Table>
      </div>
      <template #footer>
        <div class="d-flex justify-content-end">
          <button class="btn btn-secondary" @click="showSummaryPopup = false">Close</button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  PropType,
  computed,
  Ref,
  onMounted,
  reactive,
  watch,
  onUnmounted
} from "vue";
import Datepicker from "../../../../../../components/FormComponents/DatePicker.vue";

import BackBtn from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import Table from "../../../../../../components/FormComponents/NormalTable.vue";
import Supplier from "../../../../../../modules/Inventory/components/Transaction/SupplierComponent.vue";
import PoSupplierInvoiceComponent from "../../../../../../modules/Inventory/components/Transaction/PoSupplierInvoiceComponent.vue";
import Invoice from "../../../../../../modules/Inventory/components/Transaction/Invoice.vue";
import PurchaseOrder from "../../../../../../modules/Inventory/components/Transaction/PurchaseOrder.vue";
import ItemView from "../../../../../../modules/Inventory/components/Transaction/Item.vue";
import { useRoute, useRouter } from "vue-router";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import GetCode from "../../../../../../components/common/getcode.vue";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import StockInService from "../../../../Service/StockInService";
import FooterSection from "../../../../../../modules/Inventory/components/Transaction/stockin/FooterSection.vue";
import moment from "moment";
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";

import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import FooterSectionTable from "../../../../../../modules/Inventory/components/Transaction/stockin/FooterSectionTable.vue";
import StockWOTransService from "../../../../Service/WithoutStockAffectService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import CommonService from "../../../../Service/CommonService";
import CrystalReportPrintPopUp from "../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import AutoCompleteCustom from "../../../../../../components/FormComponents/AutoComplete.vue";
import listserviceOut from "../../../../../../modules/Inventory/Service/StockOutService";
import OverallItemList from "../../../../../../modules/Inventory/components/Transaction/ItemList.vue"
import ItemAllocatedTable from "../../../../../../modules/Inventory/components/Transaction/ItemAllocatedList.vue"
import Itemservice from "../../../../../../modules/Inventory/Service/ItemMasService";
import { setupHistoryManagement } from "../../../../../../modules/Inventory/Service/HistoryManage";
import StockInFileUploadServices from "../../../../../../modules/Inventory/Service/StockInFileUploadService";
import StockWOFileUploadServices from "../../../../../../modules/Inventory/Service/StockWOFileUploadService";
import common from "../../../../../../modules/Inventory/Service/CommonService";



export default defineComponent({
  components: {
    Datepicker,
    TextField,
    BackBtn,
    Headerlayout,
    Table,
    Supplier,
    ItemView,
    Footer,
    Invoice,
    PurchaseOrder,
    GetCode,
    CreateSuccessully,
    UpdatedSuccessfully,
    FooterSection,
    FooterSectionTable,
    CrystalReportPrintPopUp,
    CustomDropdown,
    AutoCompleteCustom,
    PoSupplierInvoiceComponent,
    OverallItemList,
    ItemAllocatedTable
  },

  props: {
    Operations: {
      type: Object,
      default: () => ({}),
    },
    ApprovalObj: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props) {

    //
    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //
    let RoundOffDisable = ref(false);
    const displayClass = ref("");

    const isScrolled = ref(false);
    const toast = useToast();
    const confirm = useConfirm();

    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const currentStep = ref(0);
    const BarCodeItem: any = ref([]);
    let ExcelResponse: any = ref([]);
    const route = useRoute();
    const routes = useRoute();
    let activetab = ref(0);
    let DCNoDropdownLength = ref(0);
    let EditId: any = ref(route.query.Id);

    const IsGRNApproval = ref({
      IsApproval: 0,
      BranchId: 0
    })

    watch(
      () => [props.Operations, props.ApprovalObj],
      ([newOperations, newApprovalObj]) => {
        debugger;
        if (newOperations.Id) {
          IsGRNApproval.value.IsApproval = 1
          EditId.value = newOperations.Id;
        }

        if (newApprovalObj.Status) {
          UpdateApprovalStatus(newApprovalObj.Status);
        }
      },
      { immediate: true, deep: true }
    );

    async function UpdateApprovalStatus(status) {
      debugger;
      try {
        const response = await StockInService.UpdateApprovalStatus(
          EditId.value,
          status
        );

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
          IsSubmitFunc(0);
        }
      } catch (error) {
        console.log(error);
      }
    }


    let paramnames = routes.query.param;
    const popup = ref({
      successpop: false,
      updatepop: false,
    });

    const showSummaryPopup = ref(false);

    const ParamValues = ref({
      StoreId: 0,
      status: 0,
    });

    const commonItemProps = ref({
      storeId: 0,
      type: 0,
      fieldType: 0,
      supplierId: 0,
      itemType: 2,
      IsFilter: 3,
      SupllierStateId: 0,
      UnitRateZero: 1,
      GRNFlag: true
    });

    const commonProps = ref({
      storeId: 0,
       StoreBrMapId: 0,
    });

    const DCTypeOption = ref([
      {
        name: "Consignee",
        value: 1,
      },
      {
        name: "Others",
        value: 2,
      },
      {
        name: "With PO",
        value: 3,
      }, {
        name: "Without PO",
        value: 4,
      },
    ]);

    const DataObj = ref({
      ReturnOptions: [],
      ReturnId: ref(),
    });
    const TabsActive = ref({
      AllItem: true,
      ReceivedItems: false
    })

    let RefIdByMas = ref();
    let overallTax = ref(0);
    let StoreId = routes.query.StoreId ?? 0;
    let status = routes.query.status ?? 0;
    let Type = routes.query.Type;
    ParamValues.value.StoreId = Number(StoreId);
    commonItemProps.value.storeId = Number(StoreId);
    commonProps.value.storeId = Number(StoreId);
    ParamValues.value.status = Number(status);
    let OperationId = Number(routes.query.OperationId) ?? 0;
    let Entitydata = ref();
    Entitydata.value = Number(routes.query.EntityId) ?? 0;
    let currentDate = new Date().toISOString();
    let SupplierDropDownDisable = ref(false);
    let StoreBrMapId = routes.query.storebranchmapid ?? 0;
    commonProps.value.StoreBrMapId = Number(StoreBrMapId);
    const { t } = useI18n();
    let EditFlag = 0;
    let normaltablesearch = paramnames == "GRN Without PO" ? false : true
    const CrystalReportPopup = ref(false);

    let showFields = ref({
      Name: {
        show: true,
        require: true,
      },
      Batch: {
        show: true,
        require: true,
      },
      SupplierBarCode: {
        show: true,
        require: true,
      },
      PackSize: {
        show: true,
        require: true,
      },
      // UnitRate: {
      //   show: paramnames == "DC" ? false : true,
      //   require: paramnames == "DC" ? false : true,
      // },
       UnitRate: {
        show:true,
        require:  true,
      },
      Qty: {
        show: true,
        require: true,
      },
      // MRP: {
      //   show: paramnames == "DC" ? false : true,
      //   require: paramnames == "DC" ? false : true,
      // },
        MRP: {
        show:  true,
        require: true,
      },
      Discount: {
        show: true,
        require: false,
      },
      AvailQty: {
        show: false,
        require: false,
      },
      IssuedQty: {
        show: false,
        require: false,
      },
      RequestedQty: {
        show: false,
        require: false,
      },
      transportcharges: {
        show: false,
        require: false,
      },
      servicecharges: {
        show: true,
        require: false,
      },
      // othercharges: {
      //   show: paramnames == "DC" ? false : true,
      //   require: paramnames == "DC" ? false : true,
      // },
       othercharges: {
        show:  true,
        require: true,
      },
      ExpiryDate: {
        show: true,
        require: true,
      },
      Brand: {
        show: true,
        require: false,
      },
      ModelNumber: {
        show: true,
        require: false,
      },
      Size: {
        show: true,
        require: false,
      },
      Room: {
        show: true,
        require: false,
      },
      Rack: {
        show: true,
        require: false,
      },
      Row: {
        show: true,
        require: false,
      },
      Box: {
        show: true,
        require: false,
      },
      ManufactureDt: {
        show: true,
        require: false,
      },
      ExcelImport: {
        show: true,
      },
      promoqty: {
        show: paramnames == 'GRN With PO' ? false : true,
        require: true,
      },
      IsFreeQty: {
        show: paramnames == 'DC' ? false : true,
        require: true,
      },
      UOM: {
        show: true,
        require: true,
      },
    });

    const model = ref({
      DocNo: "",
    });

    const dataId = ref({
      purchaseId: 0,
    });

    let items: any = ref([]);
    let recieveditems: any = ref([]);
    let recieveditemsOrg: any = ref([]);
    let itemcatfilteroptions: any = ref([]);
    let additems: any = ref([]);
    const loading = ref(false);
    let fullPath = ref();
    let uploadedTableList: any = ref([])
    let DeletedFileUpload: any = []
    const StockWOFileUpload = ref([]);

    let IsDraft: any = ref(route.query.IsDraft);

    const paramValue = computed(() => {
      return route.query.param as string;
    });
    const hideFooter = computed(() => {
      return EditId.value && currentStep.value === 0 && recieveditems.value.length;
    });

    let List = ref([]);
    const dataItems = ref({});
    const router = useRouter();
    const taxvalues: any = ref([]);
    const itemDatas = ref([]);
    const nonFilterDatas = ref([]);
    var nonFilterDatasCopy: any = [];
    let IsBatch = true;
    let SelectList: any = ref([]);
    let ListSelect: any = ref([]);
    const dupitems: any = ref([]);
    let IsCategoryFilter = false;

    const requestForm = ref({
      DocType: "8",
      DocNo: "",
      DocDate: currentDate,
      StoreId: 0,
      FromStore: 0,
      ToStore: 0,
      TotalQty: 0,
      SupplierId: 0,
      Remarks: "",
      Id: 0,
      InvoiceNo: "",
      InvoiceDate: "",
      InwardDate: currentDate,
      DcDate: currentDate,
      TotalTransportCharges: 0.0,
      TotalServiceCharges: 0.0,
      TotalOtherCharges: 0.0,
      NetAmount: 0.0,
      Amount: 0.0,
      TaxAmount: 0.0,
      DiscountAmount: 0.0,
      FormId: "",
      RefId: 0,
      RefNo: "",
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      IsApproved: 0,
      GRNTransportationCharges: "0.00",
      GRNOtherCharges: "0.00",
      GRNDiscount: "0.00",
      DCType: ref(),
      GRNTransportationTax: "0.00",
      GRNFreightCharges: "0.00",
      GRNFreightTax: "0.00",

      SGSTTaxAmount: 0.0,
      CGSTTaxAmount: 0.0,
      IGSTTaxAmount: 0.0,
      RoundOff: "0.00",
      StoreBrMapId: 0,

      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      IsDraft: 0,
      IsApproval: 0,
      StockInDetailList: []
    });

    if (paramnames == "GRN With PO") {
      requestForm.value.FormId = "1022";
      requestForm.value.DocType = "7";
      SupplierDropDownDisable.value = false;
      RoundOffDisable.value = false
    } else if (paramnames == "GRN Without PO") {
      requestForm.value.FormId = "1023";
      requestForm.value.DocType = "8";
      SupplierDropDownDisable.value = false;
      RoundOffDisable.value = false
    } else if (paramnames == "DC") {
      requestForm.value.FormId = "0";
      requestForm.value.DocType = "19";
      SupplierDropDownDisable.value = false;
      RoundOffDisable.value = false
    }

    const invDetails = ref({
      InvoiceNo: "",
      // InvoiceDate: paramnames == "DC" ? moment().format("DD-MM-YYYY") : "",
      InvoiceDate: paramnames == "DC" ? new Date() : "",
    });

    // let SupformData = ref({
    //   SupplierId: ref(),
    //   StateId: 0,
    // });

    const PurchaseformData = ref({
      purchaseId: 0,
      purchaseName: "",
      purchase: "",
      disabled: false,
      SupplierId: ref(0),
      CreatedAt: ref(),
      StateId: 0,
    });
    let OriginalPoAmount = ref(0)
    var arr: any = [];

    //Item Edit
    function IsItemEdit(data) {
      debugger;
      dataItems.value = {};
      dataItems.value = data;
      dataItems.value["IsEdit"] = 1;
      EditFlag = 1;
      displayClass.value = "show";
    }

    function clearItems(value1) {
      debugger;
      if (EditFlag == 1 && paramnames == "GRN With PO") {
        IsSubmit()
      }
    }

    const grossvalues: any = ref({
      grossamount: 0.00,
      totaldiscountamount: 0.00,
      taxamount: 0.00,
      transportcharges: 0.00,
      freightcharges: 0.00,
      servicecharges: 0.00,
      othercharges: 0.00,
      netamount: 0.00,
      totalqty: 0.0,

      sgsttaxamount: 0.00,
      cgsttaxamount: 0.00,
      igsttaxamount: 0.00
    });

    let GRNOverAllChrg = {
      GRNTransportationCharges: 0.0,
      GRNOtherCharges: 0.0,
      GRNDiscount: 0.0,
      GRNTransportationTax: 0.0,
      GRNFreightCharges: 0.0,
      GRNFreightTax: 0.0,
    };



    onMounted(() => {
      debugger;
      if (EditId.value) {
        if (IsDraft._value == "1") {
          tabMove.value = true
          currentStep.value = 0
        }
        else {
          tabMove.value = true
          currentStep.value = 1
        }
        IsEdit();
      } else {
      }


    });
    // const handleScroll = () => {
    //   alert('scrolling');
    //   debugger;
    //   isScrolled.value = window.scrollY > 0;
    // };
    if (window.scrollY > 0) {
      isScrolled.value = window.scrollY > 0;
    }
    // window.addEventListener('scroll', handleScroll);
    // onUnmounted(() => {
    //   window.removeEventListener('scroll', handleScroll);
    // });

    const headers = computed(() => [
      {
        header: t('storetabdetails.grncreationtable.Code'),
        field: "ItemProductId",
        class: "smallwidth normalcolumnfreezeleft1"

      },
      // {
      //   header: "Item Code",
      //   field: "ItemProductId",
      // },

      {
        header: t('storetabdetails.grncreationtable.Name'),
        field: "Itemname1",
        slot: "Itemname1",
        sortable: false,
        fieldDisplay: "false",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth normalcolumnfreezeleft2",
      },
      {
        header: t('storetabdetails.grncreationtable.Brand/ModelNumber/Size'),
        field: "BrandName",
        fieldDisplay: "false",
        slot: "combinedFieldSlot",
        class: "mediumwidth normalcolumnfreezeleft3",
      },
      {
        header: t('storetabdetails.grncreationtable.Qty'),
        field: "",
        slot: "Qty",
        sortable: false,
        fieldDisplay: "false",
        class: "smallwidth"
      },

      {
        header: t('storetabdetails.grncreationtable.POQty'),
        field: "RequestedQty",
        class: paramnames == "GRN With PO" || (paramnames == "DC" && requestForm.value.DCType == 3) ? "smallwidth" : "d-none",
        bodyclass: "right_td",
      },
      {
        header: t('storetabdetails.grncreationtable.dcqty'),
        field: "DCQuantity",
        class: (paramnames == "GRN With PO" || paramnames == "GRN Without PO") && DCNoDropdownLength.value != 0 ? "smallwidth" : "d-none",
        bodyclass: "right_td",
      },
      {
        header: t('storetabdetails.grncreationtable.FreeQty'),
        field: "FreeQty",
        slot: "FreeQty",
        sortable: false,
        fieldDisplay: "false",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.BatchNo'),
        field: "BatchNo",
        slot: "BatchNo",
        sortable: false,
        fieldDisplay: "false",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.ExpiryDate'),
        field: "ExpiryDate",
        slot: "ExpiryDate",
        sortable: false,
        fieldDisplay: "false",
        class: "mediumwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.MRP'),
        field: "",
        slot: "MRPSlot",
        sortable: false,
        fieldDisplay: "false",
        // class: paramnames == "DC" ? "d-none" : "smallwidth"
        class:  "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.HSN'),
        field: "HSNCode",
        class: "smallwidth"

      },
      {
        header: t('storetabdetails.grncreationtable.PurchasingUnit'),
        field: "OrderingName",
        class: "smallwidth"

      },
      {
        header: t('storetabdetails.grncreationtable.UOM'),
        field: "DispensingName",
        class: "smallwidth"

      },
      {
        header: t('storetabdetails.grncreationtable.UOMName'),
        field: "UOMName",
        class: "smallwidth"
      },

      {
        header: t('storetabdetails.grncreationtable.ManufactureDate'),
        field: "ManufactureDt",
        slot: "ManufactureDate",
        sortable: false,
        fieldDisplay: "false",
        class: "mediumwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.UnitRate'),
        field: "",
        slot: "UnitRateSlot",
        sortable: false,
        fieldDisplay: "false",
        bodyclass: "right_td",
        // class: paramnames == "DC" ? "d-none" : "smallwidth"
        class: "smallwidth"
      },

      {
        header: t('storetabdetails.grncreationtable.Rate'),
        field: "Rate",
        bodyclass: "right_td",
        // class: paramnames == "DC" ? "d-none" : "smallwidth"
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.Discount%'),
        field: "Discount",
        slot: "Discount",
        sortable: false,
        fieldDisplay: "false",
      },
      {
        header: t('storetabdetails.grncreationtable.Discount'),
        field: "Discountamount",
        bodyclass: "right_td",
        slot: "DiscountAmount",
        fieldDisplay: "false",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.Tax%'),
        field: "PurchasePercentage",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.Tax'),
        field: "Purchasetaxamount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.SGST%'),
        field: "SGSTTax",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.SGST'),
        field: "SGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.CGST%'),
        field: "CGSTTax",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.CGST'),
        field: "CGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.IGST%'),
        field: "IGSTTax",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.IGST'),
        field: "IGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.ServiceCharges'),
        field: "servicecharges",
        slot: "servicecharges",
        sortable: false,
        fieldDisplay: "false",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.OtherCharges'),
        field: "othercharges",
        slot: "othercharges",
        sortable: false,
        fieldDisplay: "false",
        bodyclass: "right_td",
        // class: paramnames == "DC" ? "d-none" : "smallwidth"
        class: "smallwidth",

      },
      {
        header: t('storetabdetails.grncreationtable.Total'),
        field: "Totalvalue",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.SupplierBarCode'),
        field: "SupplierBarCode",
        slot: "SupplierBarCode",
        sortable: false,
        fieldDisplay: "false",
        class: "smallwidth"
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "last-column-position",
        fieldDisplay: "false",
      },
    ]);

    const AddItems = async (value) => {
      debugger;
      console.log(value);
      if (paramnames == "GRN With PO") {
        // additems.value = value.map((item) => {
        //  item.IsFreeItem = item.StockDetailsId == 0 ? 1 : 0;
        //  return item;

        items.value = value.map((item) => {
          if (item.IsFreeQtyItem == 1) {
            item.IsFreeItem = 0;
            item.IsFreeQtyItem = item.StockDetailsId == 0 ? 1 : 0;
          }
          else {
            item.IsFreeItem = item.StockDetailsId == 0 ? 1 : 0;
            if (item.IsFreeItem == 1) {
              item.UnitRate = 0.00;
              item.Rate = 0.00;
              item.PurchasePercentage = 0.00;
              item.Purchasetaxamount = 0.00;
              item.SGSTTax = 0.00;
              item.SGSTTaxAmount = 0.00;
              item.CGSTTax = 0.00;
              item.CGSTTaxAmount = 0.00;
              item.IGSTTax = 0.00;
              item.IGSTTaxAmount = 0.00;
              item.Discount = 0.00;
              item.Discountamount = 0.00;
              item.Totalvalue = 0.00;
              item.servicecharges = 0.00;
              item.othercharges = 0.00;
              item.transportcharges = 0.00;
            }

            item.IsFreeQtyItem = 0;
          }
          return item;
        });
        //; });

        items.value.push(...additems.value);
      }
      else {
        items.value = value.map((item) => {

          if (item.IsFreeItem == 1 || item.IsFreeQtyItem == 1) {
            item.UnitRate = 0.00;
          }
          return item;
        });
        items.value = value
      }

      if (paramnames == "GRN Without PO" && DCNoDropdownLength.value == 0) {
        await IsSubmitDraft()
      }

      // items.value = value.map(obj => ({
      //   ...obj,
      //   // UnitRate: obj.UnitRate.toFixed(2),
      //   // Rate: obj.Rate.toFixed(2)

      // }));

      // if (paramnames == "GRN With PO") {
      //   grossvalues.value.totalqty = items.value.reduce((acc, items) => acc + Number(items.ItemQuantity), 0);
      // }
    };

    // const AddselectedItem = async (value) => {
    //   debugger;
    //   console.log(value);
    //   // recieveditems.value=
    //   SelectList.value = value;
    // };

    const AddselectedItem = async (value) => {
      debugger;
      SelectList.value = value;

      // Only perform calculations if items.value is empty
      if (items.value.length === 0) {
        await GRNCalcDetailsClear();

        // Calculate totals based on selected items
        for (let i = 0; i < SelectList.value.length; i++) {
          const item = SelectList.value[i];

          grossvalues.value.grossamount += parseFloat(item.Rate || 0.00);
          grossvalues.value.totaldiscountamount += parseFloat(item.Discountamount || 0.00);
          grossvalues.value.taxamount += parseFloat(item.Purchasetaxamount);
          grossvalues.value.servicecharges += parseFloat(item.servicecharges || 0.00);
          grossvalues.value.othercharges += parseFloat(item.othercharges || 0.00);
          grossvalues.value.sgsttaxamount += parseFloat(item.SGSTTaxAmount);
          grossvalues.value.cgsttaxamount += parseFloat(item.CGSTTaxAmount);
          grossvalues.value.igsttaxamount += parseFloat(item.IGSTTaxAmount);
          grossvalues.value.totalqty += parseFloat(item.ItemQuantity || 0);
        }

        // Format numbers
        grossvalues.value.grossamount = Number(grossvalues.value.grossamount).toFixed(2);
        grossvalues.value.totaldiscountamount = Number(Number(requestForm.value.GRNDiscount || 0.00) + Number(grossvalues.value.totaldiscountamount || 0.00)).toFixed(2);
        grossvalues.value.taxamount = Number(grossvalues.value.taxamount).toFixed(2);
        grossvalues.value.servicecharges = Number(grossvalues.value.servicecharges || 0.00).toFixed(2);
        grossvalues.value.othercharges = Number(Number(requestForm.value.GRNOtherCharges || 0.00) + Number(grossvalues.value.othercharges || 0.00)).toFixed(2);
        grossvalues.value.sgsttaxamount = Number(grossvalues.value.sgsttaxamount).toFixed(2);
        grossvalues.value.cgsttaxamount = Number(grossvalues.value.cgsttaxamount).toFixed(2);
        grossvalues.value.igsttaxamount = Number(grossvalues.value.igsttaxamount).toFixed(2);

        await GRNSubcalculation(0);

        // Update tax calculations if needed
        if (paramnames == "GRN With PO") {
          taxCalculation(SelectList.value);
        }
      }
    };

    watch(SelectList, (newSelectList, oldSelectList) => {
      if (items.value.length === 0 && newSelectList.length !== oldSelectList.length) {
        debouncedGRNCalculation();
      }
    }, { deep: true });

    function delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }


    async function AddAllItem(data) {
      debugger
      for (let i = 0; i < data.length; i++) {

        if (data[i]["ItemQuantity"] == "") {
          loading.value = false;

          toast.add({
            severity: "warn",
            summary: "Qty required",
            detail: `Please provide a qty for the item: ${data[i]["Itemname1"]}.`,
            life: 3000,
          });
          return false;
        }

        if (data[i]["BatchRequired"] == true && !data[i]["BatchNo"]) {
          IsBatch = false;  // Set to false if any batch number is missing
          loading.value = false;
          toast.add({
            severity: "warn",
            summary: "Batch Number Required",
            detail: `Please provide a batch number for the item: ${data[i]["Itemname1"]}.`,
            life: 3000,
          });
          return false;
        }
        else {
          IsBatch = true;
        }
        if (data[i]["ExpiryDtRequired"] == true && !data[i]["ExpiryDate1"]) {
          loading.value = false;
          toast.add({
            severity: "warn",
            summary: "Expiry Date Required",
            detail: `Please provide an expiry date for the item: ${data[i]["Itemname1"]}.`,
            life: 3000,
          });
          return false;
        }

      }
      SelectList.value = data;
      let filterItem: any = JSON.parse(JSON.stringify(SelectList.value));


      await Object.values(SelectList.value).forEach((items1: any) => {

        let findarr = ListSelect.value.filter((i1) => i1.DCType == items1.DCType && i1.ItemId == items1.ItemId && i1.Brand == items1.Brand && i1.ModelNumber == items1.ModelNumber && i1.Size == items1.Size);
        if (EditId._value && IsDraft.value == 1 && findarr.length > 0 && paramnames != 'DC') {
          findarr[0].ItemQuantity = findarr[0].Qty;
        }
        let Qty = Number(items1.ItemQuantity);

        let alreadyadd: any = items.value.filter((i1) => i1.DCType == items1.DCType && i1.ItemId == items1.ItemId && i1.Brand == items1.Brand && i1.ModelNumber == items1.ModelNumber && i1.Size == items1.Size)

        if (alreadyadd.length > 0) {
          let alreadyQty = alreadyadd.reduce((acc, item) => Number(acc) + Number(item.ItemQuantity), 0);
          Qty = Number(Qty) + Number(alreadyQty);
        }

        if (findarr.length > 0) {

          if (Number(Qty) >= Number(findarr[0].ItemQuantity)) {

            recieveditems.value = recieveditems.value.filter((x: any) => {
              return !(
                x.DCType === items1.DCType &&
                x.ItemId === items1.ItemId &&
                x.Brand === items1.Brand &&
                x.ModelNumber === items1.ModelNumber &&
                x.Size === items1.Size
              );
            }).map((item1) => {
              item1.ManufactureDt = item1.DocType == '19' ? item1.ManufactureDt : ""
              item1.ExpiryDate1 = item1.DocType == '19' ? item1.ExpiryDate1 : ""

              return item1
            });

            SelectList.value = SelectList.value.filter((x: any) => {
              return !Object.values(SelectList.value).some((y: any) => {
                return (
                  x.DCType === y.DCType &&
                  x.ItemId === y.ItemId &&
                  x.Brand === y.Brand &&
                  x.ModelNumber === y.ModelNumber &&
                  x.Size === y.Size
                );
              });
            });
          }
          else {
            items1.ItemQuantity = Number(findarr[0].ItemQuantity) - Number(Qty);

            items1.ChkPOQty = items1.DCType == 0 ? items1.ItemQuantity : 0;
            items1.DCQuantity = items1.DCType != 0 ? items1.ItemQuantity : 0;

            items1.BatchNo = "";

            items1.Rate = Number(items1.ItemQuantity * items1.UnitRate).toFixed(2);

            let BeforeDiscountRate = items1.Rate;

            const discountAmount = ((items1.Discount || 0.00) / 100) * items1.Rate;
            items1.Discountamount = discountAmount.toFixed(2);

            items1.Rate = (items1.Rate - items1.Discountamount || 0.00).toFixed(2);

            items1.Purchasetaxamount = (items1.Rate * (items1.PurchasePercentage / 100)).toFixed(2);

            if (items1.SGSTTax && items1.CGSTTax) {
              items1.SGSTTaxAmount = Number(Number(items1.Purchasetaxamount) / 2).toFixed(2);

              items1.CGSTTaxAmount = Number(Number(items1.Purchasetaxamount) / 2).toFixed(2);
            }

            if (items1.IGSTTax) {
              items1.IGSTTaxAmount = Number((items1.PurchasePercentage * items1.Rate) / 100).toFixed(2);
            }

            items1.Rate = BeforeDiscountRate;

            items1.Totalvalue = Number((Number(items1.Rate) - Number(items1.Discountamount || 0.00)) + Number(items1.Purchasetaxamount) + Number(items1.servicecharges || 0.00) + Number(items1.othercharges || 0.00)).toFixed(2)
          }
        }
      })



      if (IsCategoryFilter != true) {
        recieveditemsOrg.value = await recieveditems.value.map((item1) => {
          item1.ItemQty1 = item1.ItemQuantity;
          item1.ManufactureDt = item1.DocType == '19' ? item1.ManufactureDt : ""
          item1.ExpiryDate1 = item1.DocType == '19' ? item1.ExpiryDate1 : ""
          return item1
        })
      }


      let dataarr = await items.value;
      await Object.values(filterItem).forEach((items1: any) => {

        let Qty = Number(items1.ItemQuantity);

        let alreadyadd = dataarr.filter((i1) => i1.DCType == items1.DCType && i1.ItemId == items1.ItemId && i1.Brand == items1.Brand && i1.ModelNumber == items1.ModelNumber && i1.Size == items1.Size)

        let alreadyBatch = dataarr.filter((i1) => i1.DCType == items1.DCType && i1.ItemId == items1.ItemId && i1.BatchNo == items1.BatchNo && i1.BatchRequired == true && i1.Brand == items1.Brand && i1.ModelNumber == items1.ModelNumber && i1.Size == items1.Size)

        if ((alreadyadd.length > 0 && alreadyadd[0]?.BatchRequired == false) || (alreadyBatch.length > 0)) {
          if (alreadyBatch.length > 0) {
            Qty = Number(Qty) + Number(alreadyBatch[0].ItemQuantity);
            dataarr = dataarr.map((i2) => {
              if (i2.DCType == items1.DCType && i2.ItemId == items1.ItemId && i2.BatchNo == items1.BatchNo && i2.BatchRequired == true && i2.Brand == items1.Brand && i2.ModelNumber == items1.ModelNumber && i2.Size == items1.Size) {
                i2.ItemQuantity = Qty
                i2.totalqty = 0;
              }
              return i2;
            })
          }
          else {
            Qty = Number(Qty) + Number(alreadyadd[0].ItemQuantity);
            dataarr = dataarr.map((i2) => {
              if (i2.DCType == items1.DCType && i2.ItemId == items1.ItemId && i2.Brand == items1.Brand && i2.ModelNumber == items1.ModelNumber && i2.Size == items1.Size) {
                i2.ItemQuantity = Qty
                i2.totalqty = 0;
              }
              return i2;
            })
          }
        }
        else {
          dataarr.push(items1);
        }
      })

      items.value = [...dataarr];
      for (let i = 0; i < items.value.length; i++) {
        items.value[i].PoQty = items.value[i].DCType == 0 ? items.value[i].ItemQuantity : 0;
        items.value[i].DCQuantity = items.value[i].DCType != 0 ? items.value[i].ItemQuantity : 0;
      }

      items.value = items.value.map((i1) => {

        // i1.ManufactureDt = i1.ManufactureDt ? moment(i1.ManufactureDt, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("DD-MM-YYYY") : "";

        // i1.ExpiryDate = i1.ExpiryDate1 ? moment(i1.ExpiryDate1, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("DD-MM-YYYY") : "";
        // i1.ExpiryDate1 = i1.ExpiryDate1 ? moment(i1.ExpiryDate1, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("DD-MM-YYYY") : "";

        if (i1.ManufactureDt) {
          // Check if the date is already in DD-MM-YYYY format
          const isAlreadyFormatted = moment(i1.ManufactureDt, "DD-MM-YYYY", true).isValid();
          if (isAlreadyFormatted) {
            i1.ManufactureDt = i1.ManufactureDt;

          } else {
            i1.ManufactureDt = moment(i1.ManufactureDt, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("DD-MM-YYYY");
          }
        } else {
          i1.ManufactureDt = "";
        }

        if (i1.ExpiryDate1) {
          // Check if the date is already in DD-MM-YYYY format
          const isAlreadyFormatted = moment(i1.ExpiryDate1, "DD-MM-YYYY", true).isValid();
          if (isAlreadyFormatted) {
            i1.ExpiryDate = i1.ExpiryDate1;
            i1.ExpiryDate1 = i1.ExpiryDate1;

          } else {
            i1.ExpiryDate = moment(i1.ExpiryDate1, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("DD-MM-YYYY");
            i1.ExpiryDate1 = moment(i1.ExpiryDate1, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("DD-MM-YYYY");
          }
        } else if (i1.ExpiryDate) {
          i1.ExpiryDate1 = i1.ExpiryDate;
        } else {
          i1.ExpiryDate = "";
          i1.ExpiryDate1 = "";
        }

        i1.Rate = Number(i1.ItemQuantity * i1.UnitRate).toFixed(2);

        let BeforeDiscountRate = i1.Rate;
        const discountAmount = ((i1.Discount || 0.00) / 100) * i1.Rate;
        i1.Discountamount = discountAmount.toFixed(2);

        i1.Rate = (i1.Rate - i1.Discountamount || 0.00).toFixed(2);

        i1.Purchasetaxamount = (i1.Rate * (i1.PurchasePercentage / 100)).toFixed(2);

        if (i1.SGSTTax && i1.CGSTTax) {
          i1.SGSTTaxAmount = Number(Number(i1.Purchasetaxamount) / 2).toFixed(2);

          i1.CGSTTaxAmount = Number(Number(i1.Purchasetaxamount) / 2).toFixed(2);
        }

        if (i1.IGSTTax) {
          i1.IGSTTaxAmount = Number((i1.PurchasePercentage * i1.Rate) / 100).toFixed(2);
        }

        i1.Rate = BeforeDiscountRate;

        i1.Totalvalue = Number((Number(i1.Rate) - Number(i1.Discountamount || 0.00)) + Number(i1.Purchasetaxamount) + Number(i1.servicecharges || 0.00) + Number(i1.othercharges || 0.00)).toFixed(2)

        return i1;
      })

      SelectList.value = SelectList.value.map((i1) => {
        i1.ManufactureDt = i1.DocType == '19' ? i1.ManufactureDt : "";
        i1.ExpiryDate1 = i1.DocType == '19' ? i1.ExpiryDate1 : "";

        return i1;
      })


      dupitems.value = []
      const lastIndex = Number(items.value.length - 1);
      dupitems.value.push(items.value[lastIndex])
      await IsSubmitDraft();
    }


    async function FilterByCategory(CategoryId) {
      debugger;
      if (CategoryId) {
        IsCategoryFilter = true;
        // recieveditems.value = recieveditemsOrg.value.filter((item) => item.CategoryId == CategoryId).map((i1) => {
        //   i1.ItemQuantity = i1.ItemQty1;
        //   return i1;
        // });
      }
      else {

        recieveditemsOrg.value = recieveditemsOrg.value.filter((i2) =>
          !items.value.some((i1) =>
            i1.ItemId === i2.ItemId &&
            i1.Brand === i2.Brand &&
            i1.ModelNumber === i2.ModelNumber &&
            i1.Size === i2.Size &&
            i1.BatchNo === i2.BatchNo
          )
        );

        recieveditems.value = recieveditemsOrg.value.map((i1) => {
          i1.ItemQuantity = ref(i1.ItemQty1);
          return i1;
        });

        itemcatfilteroptions.value = recieveditems.value.reduce((acc: any, current) => {
          const { CategoryId, ItemCategory1 }: any = current;
          const existingCategory: any = acc.find(item => item["value"] == CategoryId);
          if (existingCategory) {
            existingCategory.count++;
          } else {
            acc.push({ value: CategoryId, name: ItemCategory1 });
          }
          return acc;
        }, []);
      }
    }

    function ClearValues() {
      debugger;
      // grossvalues.value.grossamount = 0;
      // //grossvalues.value.taxamount = 0;


      // grossvalues.value.totaldiscountamount = grossvalues.value.totaldiscountamount !== 0
      //   ? grossvalues.value.totaldiscountamount
      //   : 0;

      // grossvalues.value.freightcharges = grossvalues.value.freightcharges !== 0
      //   ? grossvalues.value.freightcharges
      //   : 0;

      // grossvalues.value.transportcharges = grossvalues.value.transportcharges !== 0
      //   ? grossvalues.value.transportcharges
      //   : 0;

      // grossvalues.value.servicecharges = grossvalues.value.servicecharges !== 0
      //   ? grossvalues.value.servicecharges
      //   : 0;

      // grossvalues.value.othercharges = grossvalues.value.othercharges !== 0
      //   ? grossvalues.value.othercharges
      //   : 0;

      // grossvalues.value.totalqty = 0;
      // grossvalues.value.netamount = 0;

    }

    function taxCalculation(value) {
      debugger;
      let dataarr: any = [];
      taxvalues.value = [];
      let arrCount: any = [];
      value = value.filter((x) => x.IsFreeItem == 0);
      // if (nonFilterDatasCopy.length > 0 && paramnames == "GRN With PO") {
      //   value = value.filter((item) => {
      //     const data = nonFilterDatasCopy.find(
      //       (data: any) =>
      //         data.ItemId == item.ItemId
      //     );

      //     return data != null;
      //   });
      // }
      Object.values(value).forEach((item: any) => {
        if (PurchaseformData.value.StateId == session.BranchStateId) {
          let taxper = 0,
            taxAmt = 0,
            taxall = 0,
            count = 0;
          if (item.PurchaseType == 1) {
            taxper = Number(item.PurchasePercentage) / 2;
            taxAmt = Number((((Number(item.Rate) - Number(item.Discountamount || 0.00)) * taxper) / 100).toFixed(2));
            count = 2;
          } else {
            taxper = 0;
            taxAmt = Number((Number(item.PurchasePercentage || 0)).toFixed(2));
            count = 1;
          }
          let arrCount: any =
            (taxvalues.value.length > 0
              ? taxvalues.value.filter((i1: any) => i1.HSNId == item.HSNId)
              : 0) ?? 0;
          if (arrCount.length > 0) {
            Object.values(taxvalues.value).forEach((i2: any) => {
              if (i2.HSNId == item.HSNId && i2.TaxTypeId == 1) {
                i2.TaxPer = ((Number(i2.TaxPer) + Number(taxper)) || 0).toFixed(2);
                i2.TaxAmt = ((Number(i2.TaxAmt) + Number(taxAmt)) || 0).toFixed(2);
                i2.CommonTaxPer = Number(taxper)
              }
              if (i2.HSNId == item.HSNId && i2.TaxTypeId == 2) {
                i2.TaxPer = ((Number(i2.TaxPer) + Number(taxper)) || 0).toFixed(2);
                i2.TaxAmt = ((Number(i2.TaxAmt) + Number(taxAmt)) || 0).toFixed(2);
                i2.CommonTaxPer = Number(taxper)
              }
            });
          }
          else {
            for (let k = 1; k <= count; k++) {
              let obj: any = {};
              obj["HSNManualCode"] = item.HSNManulCode;
              obj["HSNCode"] = item.HSNCode;
              obj["HSNId"] = item.HSNId;
              obj["TaxType"] =
                item.PurchaseType == 1
                  ? k == 1
                    ? "CGST %"
                    : "SGST %"
                  : "GST â‚¹";
              obj["TaxPer"] = taxper;
              obj["CommonTaxPer"] = taxper;
              obj["TaxAmt"] = taxAmt;
              obj["TaxTypeId"] = k;
              dataarr.push(obj);
              taxvalues.value.push(obj);
            }
          }
        } else {
          let obj: any = {};
          let taxper = 0,
            taxAmt = 0;
          if (item.PurchaseType == 1) {

            // taxAmt = Number(((Number(item.Rate) * Number(item.PurchasePercentage)) / 100).toFixed(2));

            taxAmt = Number((((Number(item.Rate) - Number(item.Discountamount || 0.00)) * Number(item.PurchasePercentage)) / 100).toFixed(2));

          } else {

            taxAmt = Number(Number(item.Purchasetaxamount).toFixed(2));

          }
          let arrCount: any =
            (taxvalues.value.length > 0
              ? taxvalues.value.find((i1: any) => i1.HSNId == item.HSNId)
              : 0) ?? 0;
          if (arrCount.length > 0) {
            Object.values(taxvalues.value).forEach((i2: any) => {
              if (i2.HSNId == item.HSNId && i2.TaxTypeId == 1) {
                i2.TaxPer = (i2.TaxPer + taxper).toFixed(2);
                i2.TaxAmt = (i2.TaxAmt + taxAmt).toFixed(2);
                i2.CommonTaxPer = Number(taxper)

              }
            });
          } else {
            obj["HSNManualCode"] = item.HSNManualCode;
            obj["HSNCode"] = item.HSNCode;
            obj["HSNId"] = item.HSNId;
            obj["TaxType"] = item.PurchaseType == 1 ? "IGST %" : "CGST â‚¹";
            obj["TaxPer"] = item.PurchasePercentage;
            obj["CommonTaxPer"] = item.PurchasePercentage;
            obj["TaxAmt"] = taxAmt;
            obj["TaxTypeId"] = 1;
            dataarr.push(obj);
            taxvalues.value.push(obj);
          }
        }
      });
    }

    function closetrigger() {
      // if (IsGRNApproval.value.IsApproval == 0) {
      setupHistoryManagement(router, 2);
      // }
    }

    function IsSubmitFunc(IsDraft) {
      debugger;
      if (currentStep.value == 0) {
        if (IsDraft == 1) {
          EditFlag = 1;
        }
        else {
          EditFlag = 0;
        }
        IsSubmit()
      }
      else {
        SubmitItemAllocation()
      }
    }

    let tabMove = ref(false)
    //     //Insert/Update
    const IsSubmit = handleSubmit(async (values) => {
      debugger;
      loading.value = true;
      var FileUploadArray: any = [];
      if (
        paramnames == "DC" &&
        requestForm.value.DCType == 2 &&
        !requestForm.value.RefId
      ) {
        loading.value = false;
        toast.add({
          severity: "warn",
          summary: "GRN Return Code Required",
          detail: "Please select a GRN return code before proceeding.",
          life: 3000,
        });
        return false;
      }

      for (let i = 0; i < items.value.length; i++) {

        if (items.value[i]["ItemQuantity"] == "") {
          loading.value = false;

          toast.add({
            severity: "warn",
            summary: "Qty required",
            detail: `Please provide a qty for the item: ${items.value[i]["Itemname1"]}.`,
            life: 3000,
          });
          return false;
        }

        if (items.value[i]["BatchRequired"] == true && !items.value[i]["BatchNo"]) {
          IsBatch = false;  // Set to false if any batch number is missing
          loading.value = false;
          toast.add({
            severity: "warn",
            summary: "Batch Number Required",
            detail: `Please provide a batch number for the item: ${items.value[i]["Itemname1"]}.`,
            life: 3000,
          });
          return false;
        }
        else {
          IsBatch = true;
        }

      }

      if (IsBatch) {
        requestForm.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        requestForm.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );

        requestForm.value.IsApproved = 1;

        if (!EditId.value) {
          requestForm.value.BranchId = Number(routes.query.BranchId ?? 0);
        }

        requestForm.value.HospitalId = HospitalId;
        requestForm.value.ModifiedBy = UserId;
        requestForm.value.CreatedBy = UserId;

        requestForm.value.DeptRoleId = rolesData.DeptRoleMapId;

        requestForm.value.StoreId = ParamValues.value.StoreId;
        requestForm.value.StoreBrMapId = Number(StoreBrMapId);

        requestForm.value.FromStoreBranchId = paramnames == "GRN With PO" ? requestForm.value.FromStoreBranchId : Number(routes.query.BranchId ?? 0);
        requestForm.value.ToStoreBranchId = paramnames == "GRN With PO" ? requestForm.value.ToStoreBranchId : Number(routes.query.BranchId ?? 0);

        requestForm.value.FromStore = paramnames == "GRN With PO" ? requestForm.value.FromStore : ParamValues.value.StoreId;
        requestForm.value.FromStoreBrMapId = paramnames == "GRN With PO" ? requestForm.value.FromStoreBrMapId : Number(StoreBrMapId);

        requestForm.value.ToStore = paramnames == "GRN With PO" ? requestForm.value.ToStore : ParamValues.value.StoreId;
        requestForm.value.ToStoreBrMapId = paramnames == "GRN With PO" ? requestForm.value.ToStoreBrMapId : Number(StoreBrMapId);

        if (EditFlag == 1) {
          requestForm.value.IsDraft = 1
        } else {
          requestForm.value.IsDraft = 0
        }

        requestForm.value.EntityId = Number(Entitydata.value);
        requestForm.value.EntityOperationId = OperationId;

        if (items.value.length > 0) {
          requestForm.value.SupplierId = PurchaseformData.value.SupplierId;

          requestForm.value.TotalTransportCharges =
            grossvalues.value.transportcharges || 0.00;

          requestForm.value.TotalServiceCharges =
            grossvalues.value.servicecharges || 0.00;

          requestForm.value.TotalOtherCharges = grossvalues.value.othercharges || 0.00;

          requestForm.value.NetAmount = grossvalues.value.netamount || 0.00;

          requestForm.value.Amount = grossvalues.value.grossamount || 0.00;

          requestForm.value.TotalQty = grossvalues.value.totalqty || 0.00;

          requestForm.value.DiscountAmount =
            grossvalues.value.totaldiscountamount || 0.00;

          requestForm.value.TaxAmount = grossvalues.value.taxamount || 0;

          requestForm.value.SGSTTaxAmount = grossvalues.value.sgsttaxamount || 0.00;
          requestForm.value.CGSTTaxAmount = grossvalues.value.cgsttaxamount || 0.00;
          requestForm.value.IGSTTaxAmount = grossvalues.value.igsttaxamount || 0.00;

          requestForm.value.RoundOff = requestForm.value.RoundOff || "0.00";

          requestForm.value.RefId =
            paramnames == "DC" && requestForm.value.DCType == 2
              ? requestForm.value.RefId
              : PurchaseformData.value.purchaseId;

          requestForm.value.RefNo =
            paramnames == "DC" && requestForm.value.DCType == 2
              ? requestForm.value.RefNo
              : PurchaseformData.value.purchaseName;

          Object.keys(requestForm.value).forEach((key) => {
            if (invDetails.value[key])
              requestForm.value[key] = invDetails.value[key];
          });

          console.log(requestForm.value);

          requestForm.value.InvoiceDate = requestForm.value.InvoiceDate
            ? moment(
              requestForm.value.InvoiceDate).format("YYYY-MM-DDTHH:mm:ss.SSS")
            : "1900-01-01T19:17:58.632"
          // : currentDate;

          requestForm.value.IsApproval = IsGRNApproval.value.IsApproval

          //let result: any;
          let msg: String = "";
          let id: any = 0;

          if (EditId.value && requestForm.value.IsDraft == 1) {
            requestForm.value.Id = EditId.value;
          }
          debugger;
          // if (nonFilterDatasCopy.length > 0 && paramnames == "GRN With PO") {
          //   items.value = items.value.map((item) => {
          //     const isNotPresent = nonFilterDatasCopy.some((data) => {
          //       return data['ItemId'] == item['ItemId'];
          //     });
          //     (isNotPresent) ? item.IsFreeItem = 0 : item.IsFreeItem = 1
          //     return item;
          //   })
          // }

          for (let i = 0; i < items.value.length; i++) {
            let obj = {};
            obj["Id"] = items.value[i]["StockDetailsId"];
            (obj["ItemId"] = items.value[i]["ItemId"]),
              (obj["PoQty"] = items.value[i]["ItemQuantity"]),
              (obj["ActualQty"] = items.value[i]["ItemQuantity"]),
              (obj["FreeQty"] =
                items.value[i]["FreeQty"] == ""
                  ? 0
                  : Number(items.value[i]["FreeQty"]) || 0),
              (obj["RefId"] = id),
              (obj["PackSizeId"] = items.value[i]["PackSizeId"]),
              (obj["HSNId"] = items.value[i]["HSNId"]),
              (obj["UnitMRP"] = items.value[i]["MRP"] || 0),

              (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["CreatedBy"] = UserId),
              (obj["ModifiedBy"] = UserId),

              (obj["Rate"] = items.value[i]["Rate"] || 0);
            obj["UnitRate"] = items.value[i]["UnitRate"] || 0;
            obj["PurchaseTax"] = items.value[i]["PurchasePercentage"];
            obj["PurchaseTaxAmount"] = items.value[i]["Purchasetaxamount"];
            obj["SaleTax"] = items.value[i]["SalesPercentage"];
            obj["SaleTaxAmount"] = items.value[i]["Salestaxamount"];

            (obj["SGSTTax"] = items.value[i]["SGSTTax"]),
              (obj["SGSTTaxAmount"] = items.value[i]["SGSTTaxAmount"]),
              (obj["CGSTTax"] = items.value[i]["CGSTTax"]),
              (obj["CGSTTaxAmount"] = items.value[i]["CGSTTaxAmount"]),
              (obj["IGSTTax"] = items.value[i]["IGSTTax"]),
              (obj["IGSTTaxAmount"] = items.value[i]["IGSTTaxAmount"]),

              obj["DiscountPer"] =
              items.value[i]["Discount"] == "" ? 0 : items.value[i]["Discount"];
            obj["DiscountAmount"] = items.value[i]["Discountamount"];

            obj["TransportCharges"] =
              items.value[i]["transportcharges"] == ""
                ? 0
                : items.value[i]["transportcharges"] || 0;
            obj["ServiceCharges"] =
              items.value[i]["servicecharges"] == ""
                ? 0
                : items.value[i]["servicecharges"] || 0;
            obj["OtherCharges"] =
              items.value[i]["othercharges"] == ""
                ? 0
                : items.value[i]["othercharges"] || 0;
            obj["BatchNo"] =
              items.value[i]["BatchRequired"] == true
                ? items.value[i]["BatchNo"]
                : "";
            obj["TotalValue"] = items.value[i]["Totalvalue"];


            if (IsGRNApproval.value.IsApproval == 1) {
              if (items.value[i]["ExpiryDate1"] != "01-01-0001" && items.value[i]["ExpiryDate1"] != "" && items.value[i]["ExpiryDate1"] != undefined && items.value[i]["ExpiryDate1"] != "Invalid date") {
                obj["ExpiryDate"] = moment(
                  items.value[i]["ExpiryDate1"],
                  "DD-MM-YYYY"
                ).format("YYYY-MM-DD");
              } else {
                obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
              }
            } else {
              if (items.value[i]["ExpiryDate"] != "01-01-0001" && items.value[i]["ExpiryDate"] != "" && items.value[i]["ExpiryDate"] != undefined && items.value[i]["ExpiryDate"] != "Invalid date") {
                obj["ExpiryDate"] = moment(
                  items.value[i]["ExpiryDate"],
                  "DD-MM-YYYY"
                ).format("YYYY-MM-DD");
              } else {
                obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
              }
            }
            // if (items.value[i]["ExpiryDate1"] != "01-01-0001" && items.value[i]["ExpiryDate1"] != "" && items.value[i]["ExpiryDate1"] != undefined) {
            //   obj["ExpiryDate"] = moment(
            //     items.value[i]["ExpiryDate1"],
            //     "DD-MM-YYYY"
            //   ).format("YYYY-MM-DD");
            // } else {
            //   obj["ExpiryDate"] = obj["ExpiryDate"] ? obj["ExpiryDate"] : "1900-01-01T19:17:58.632+05:30";
            // }

            if (items.value[i]["ManufactureDate"] != "01-01-0001" && items.value[i]["ManufactureDate"] != "" && items.value[i]["ManufactureDate"] != undefined) {
              obj["ManufactureDate"] = moment(
                items.value[i]["ManufactureDate"],
                "DD-MM-YYYY"
              ).format("YYYY-MM-DD");
            } else {
              obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
            }

            // if (items.value[i]["ManufactureDt"] != "01-01-0001" && items.value[i]["ManufactureDt"] != "" && items.value[i]["ManufactureDt"] != undefined) {
            //   obj["ManufactureDate"] = moment(
            //     items.value[i]["ManufactureDt"],
            //     "DD-MM-YYYY"
            //   ).format("YYYY-MM-DD");
            // } else {
            //   obj["ManufactureDate"] = obj["ManufactureDate"] ? obj["ManufactureDate"] : "1900-01-01T19:17:58.632+05:30";
            // }

            obj["Qty"] =
              items.value[i]["ItemQuantity"];

            obj["Brand"] =
              items.value[i]["Brand"] == null ? 0 : items.value[i]["Brand"];

            obj["ModelNumber"] =
              items.value[i]["ModelNumber"] == null
                ? 0
                : items.value[i]["ModelNumber"];

            obj["Size"] =
              items.value[i]["Size"] == null ? 0 : items.value[i]["Size"];

            obj["IsApproved"] = 1;

            (obj["IsConsigneeItem"] = items.value[i]["IsConsigneeItem"] || 0),
              (obj["ConsigneeBarCodeNo"] = items.value[i]["BarCodeNo"] || 0);


            obj["RoomId"] = items.value[i]["RoomId"] || 0;
            obj["RackId"] = items.value[i]["RackId"] || 0;
            obj["RowId"] = items.value[i]["RowId"] || 0;
            obj["BoxId"] = items.value[i]["BoxId"] || 0;
            obj["IsFreeItem"] = items.value[i]["IsFreeItem"] || 0;

            (obj["SupplierBarCode"] = items.value[i]["SupplierBarCode"]);

            (obj["UOM"] = items.value[i]["UOM"]);

            (obj["DCType"] = paramnames == "DC" ? requestForm.value.DCType : 0);

            (obj["StockInId"] = items.value[i]["StockInId"] || 0);
            (obj["StockInDetailId"] = items.value[i]["StockInDetailId"] || 0);
            (obj["AssetFlag"] = items.value[i]["Asset"] === true ? 1 : 0);

            (obj["StockWoId"] = items.value[i]["StockWoId"] || 0);
            (obj["StockWoDetailId"] = items.value[i]["StockWoDetailId"] || 0);

            (obj["StockoutId"] = items.value[i]["StockOutId"] || 0);
            (obj["StockoutDetailId"] = items.value[i]["StockOutDetailId"] || 0);

            obj["IsFreeQtyItem"] = items.value[i]["IsFreeQtyItem"] || 0;

            arr[i] = obj;
          }
          requestForm.value.StockInDetailList = arr
          let result = await StockInService.createStockInDetailsDraft(requestForm.value);
          id = result["result"][0]['Id'];
          requestForm.value.Id = id
          let Msg = result["result"][0]['SuccessMsg'];
          if (Msg == "Invoice Exists") {
            loading.value = false;
            toast.add({
              severity: "warn",
              summary: "Invoice Number Already Exists",
              detail: "The invoice number you entered already exists for this supplier. Please provide a unique invoice number.",
              life: 10000,
            });
            requestForm.value.InvoiceNo = "";
            invDetails.value.InvoiceNo = "";
            return false;
          }
          if (uploadedTableList.value.length != 0) {
            for (let i = 0; i < uploadedTableList.value.length; i++) {
              let Fileobj = {};
              (Fileobj["Id"] = uploadedTableList.value[i].Id),
                (Fileobj["DocType"] = requestForm.value.DocType),
                (Fileobj["RefId"] = id),
                (Fileobj["FileName"] = uploadedTableList.value[i].fileName),
                (Fileobj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
                (Fileobj["CreatedBy"] = UserId),
                (Fileobj["ModifiedBy"] = 0),
                (Fileobj["EntityId"] = Number(Entitydata.value)),
                (Fileobj["IsApproved"] = 0),
                FileUploadArray.push(Fileobj)
            }
            StockWOFileUpload.value = FileUploadArray
            let FileUploadResult = await StockInFileUploadServices.insertStockWOFile(StockWOFileUpload.value);
          }
          if (DeletedFileUpload.length > 0) {
            debugger
            let result = await StockInFileUploadServices.DeleteList(DeletedFileUpload.join(','));
          }
          arr = []
          let msgMapping = result["ErrorInfo"].ErrorCode;
          if (msgMapping == null) {
            if (EditFlag != 1) {
              if (currentStep.value < stepslist.value.length - 1) {
                loading.value = false;
                currentStep.value++;
              }
              EditId.value = result["result"][0].Id;
              tabMove.value = true;
            }
            else {
              alert(
                "your data has been saved for future editing. You can continue to work on your submission later."
              );
              setupHistoryManagement(router, 2);
            }
          }
        } else {
          loading.value = false;
          toast.add({
            severity: "warn",
            summary: "Items Required",
            detail: "Please choose items before proceeding.",
            life: 3000,
          });
        }
      }
    });


    const IsSubmitDraft = async () => {
      debugger;
      // loading.value = true;
      var FileUploadArray: any = [];
      if (
        paramnames == "DC" &&
        requestForm.value.DCType == 2 &&
        !requestForm.value.RefId
      ) {
        // loading.value = false;
        toast.add({
          severity: "warn",
          summary: "GRN Return Code Required",
          detail: "Please select a GRN return code before proceeding.",
          life: 3000,
        });
        return false;
      }
      if (IsBatch) {
        requestForm.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        requestForm.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        requestForm.value.IsApproved = 1;
        requestForm.value.BranchId = Number(routes.query.BranchId ?? 0);
        requestForm.value.HospitalId = HospitalId;
        requestForm.value.ModifiedBy = UserId;
        requestForm.value.CreatedBy = UserId;
        requestForm.value.DeptRoleId = rolesData.DeptRoleMapId;
        requestForm.value.StoreId = ParamValues.value.StoreId;
        requestForm.value.StoreBrMapId = Number(StoreBrMapId);
        requestForm.value.FromStoreBranchId = paramnames == "GRN With PO" ? requestForm.value.FromStoreBranchId : Number(routes.query.BranchId ?? 0);
        requestForm.value.ToStoreBranchId = paramnames == "GRN With PO" ? requestForm.value.ToStoreBranchId : Number(routes.query.BranchId ?? 0);
        requestForm.value.FromStore = paramnames == "GRN With PO" ? requestForm.value.FromStore : ParamValues.value.StoreId;
        requestForm.value.FromStoreBrMapId = paramnames == "GRN With PO" ? requestForm.value.FromStoreBrMapId : Number(StoreBrMapId);
        requestForm.value.ToStore = paramnames == "GRN With PO" ? requestForm.value.ToStore : ParamValues.value.StoreId;
        requestForm.value.ToStoreBrMapId = paramnames == "GRN With PO" ? requestForm.value.ToStoreBrMapId : Number(StoreBrMapId);
        requestForm.value.IsDraft = 1;
        requestForm.value.EntityId = Number(Entitydata.value);
        requestForm.value.EntityOperationId = OperationId;
        if (items.value.length > 0) {
          requestForm.value.SupplierId = PurchaseformData.value.SupplierId;
          requestForm.value.TotalTransportCharges =
            grossvalues.value.transportcharges || 0.00;
          requestForm.value.TotalServiceCharges =
            grossvalues.value.servicecharges || 0.00;
          requestForm.value.TotalOtherCharges = grossvalues.value.othercharges || 0.00;
          requestForm.value.NetAmount = grossvalues.value.netamount || 0.00;
          requestForm.value.Amount = grossvalues.value.grossamount || 0.00;
          requestForm.value.TotalQty = grossvalues.value.totalqty || 0.00;
          requestForm.value.DiscountAmount =
            grossvalues.value.totaldiscountamount || 0.00;
          requestForm.value.TaxAmount = grossvalues.value.taxamount || 0;
          requestForm.value.SGSTTaxAmount = grossvalues.value.sgsttaxamount || 0.00;
          requestForm.value.CGSTTaxAmount = grossvalues.value.cgsttaxamount || 0.00;
          requestForm.value.IGSTTaxAmount = grossvalues.value.igsttaxamount || 0.00;

          requestForm.value.RoundOff = requestForm.value.RoundOff || "0.00";
          requestForm.value.RefId =
            paramnames == "DC" && requestForm.value.DCType == 2
              ? requestForm.value.RefId
              : PurchaseformData.value.purchaseId;
          requestForm.value.RefNo =
            paramnames == "DC" && requestForm.value.DCType == 2
              ? requestForm.value.RefNo
              : PurchaseformData.value.purchaseName;
          Object.keys(requestForm.value).forEach((key) => {
            if (invDetails.value[key])
              requestForm.value[key] = invDetails.value[key];
          });
          console.log(requestForm.value);

          requestForm.value.InvoiceDate = requestForm.value.InvoiceDate
            ? moment(
              requestForm.value.InvoiceDate).format("YYYY-MM-DDTHH:mm:ss.SSS")
            : "1900-01-01T19:17:58.632"
          //: currentDate;

          let result: any;
          let msg: String = "";
          let id: any = 0;
          if (EditId.value && requestForm.value.IsDraft == 0) {
            requestForm.value.Id = EditId.value;
            if (currentStep.value < stepslist.value.length - 1) {
              // loading.value = false;
              currentStep.value++;
            }

            // result = await StockInService.updateStockInTM(requestForm.value);
            // msg = "Updated Successfully";
            // id = EditId.value;

          } else {
            debugger;
            // if (nonFilterDatasCopy.length > 0 && paramnames == "GRN With PO") {
            //   items.value = items.value.map((item) => {
            //     const isNotPresent = nonFilterDatasCopy.some((data) => {
            //       return data['ItemId'] == item['ItemId'];
            //     });
            //     items.ExpiryDate = moment(items.ExpiryDate).format('DD-MM-YYYY'),
            //       items.ExpiryDate1 = moment(items.ExpiryDate1).format('DD-MM-YYYY'),

            //       (isNotPresent) ? item.IsFreeItem = 0 : item.IsFreeItem = 1
            //     return item;
            //   })
            // }
            for (let i = 0; i < items.value.length; i++) {
              let obj = {};
              obj["Id"] = items.value[i]["StockDetailsId"];

              (obj["ItemId"] = items.value[i]["ItemId"]),
                (obj["PoQty"] = items.value[i]["ItemQuantity"]),
                (obj["ActualQty"] = items.value[i]["ItemQuantity"]),
                (obj["FreeQty"] =
                  items.value[i]["FreeQty"] == ""
                    ? 0
                    : Number(items.value[i]["FreeQty"]) || 0),
                (obj["RefId"] = id),
                (obj["PackSizeId"] = items.value[i]["PackSizeId"]),
                (obj["HSNId"] = items.value[i]["HSNId"]),
                (obj["UnitMRP"] = items.value[i]["MRP"] || 0),
                (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
                (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
                (obj["CreatedBy"] = UserId),
                (obj["ModifiedBy"] = UserId),
                (obj["Rate"] = items.value[i]["Rate"] || 0);
              obj["UnitRate"] = items.value[i]["UnitRate"] || 0;
              obj["PurchaseTax"] = items.value[i]["PurchasePercentage"];
              obj["PurchaseTaxAmount"] = items.value[i]["Purchasetaxamount"];
              obj["SaleTax"] = items.value[i]["SalesPercentage"];
              obj["SaleTaxAmount"] = items.value[i]["Salestaxamount"];
              (obj["SGSTTax"] = items.value[i]["SGSTTax"]),
                (obj["SGSTTaxAmount"] = items.value[i]["SGSTTaxAmount"]),
                (obj["CGSTTax"] = items.value[i]["CGSTTax"]),
                (obj["CGSTTaxAmount"] = items.value[i]["CGSTTaxAmount"]),
                (obj["IGSTTax"] = items.value[i]["IGSTTax"]),
                (obj["IGSTTaxAmount"] = items.value[i]["IGSTTaxAmount"]),
                obj["DiscountPer"] =
                items.value[i]["Discount"] == "" ? 0 : items.value[i]["Discount"];
              obj["DiscountAmount"] = items.value[i]["Discountamount"];
              obj["TransportCharges"] =
                items.value[i]["transportcharges"] == ""
                  ? 0
                  : items.value[i]["transportcharges"] || 0;
              obj["ServiceCharges"] =
                items.value[i]["servicecharges"] == ""
                  ? 0
                  : items.value[i]["servicecharges"] || 0;
              obj["OtherCharges"] =
                items.value[i]["othercharges"] == ""
                  ? 0
                  : items.value[i]["othercharges"] || 0;
              obj["BatchNo"] =
                items.value[i]["BatchRequired"] == true
                  ? items.value[i]["BatchNo"]
                  : "";
              obj["TotalValue"] = items.value[i]["Totalvalue"];
              // if (items.value[i]["ExpiryDate"] != "01-01-0001" && items.value[i]["ExpiryDate"] != "" && items.value[i]["ExpiryDate"] != undefined && items.value[i]["ExpiryDate"] != "Invalid date") {
              //   obj["ExpiryDate"] = moment(
              //     items.value[i]["ExpiryDate"],
              //     "DD-MM-YYYY"
              //   ).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
              // } else {
              //   obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
              // }

              if (items.value[i]["ExpiryDate1"] != "01-01-0001" && items.value[i]["ExpiryDate1"] != "" && items.value[i]["ExpiryDate1"] != undefined && items.value[i]["ExpiryDate1"] != "Invalid date") {
                obj["ExpiryDate"] = moment(
                  items.value[i]["ExpiryDate1"],
                  "DD-MM-YYYY"
                ).format("YYYY-MM-DD");
              } else {
                obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
              }

              if (items.value[i]["ManufactureDate"] != "01-01-0001" && items.value[i]["ManufactureDate"] != "" && items.value[i]["ManufactureDate"] != undefined) {
                obj["ManufactureDate"] = moment(
                  items.value[i]["ManufactureDate"],
                  "DD-MM-YYYY"
                ).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
              } else {
                obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
              }

              // if (items.value[i]["ManufactureDt"] != "01-01-0001" && items.value[i]["ManufactureDt"] != "") {
              //   obj["ManufactureDate"] = moment(
              //     items.value[i]["ManufactureDt"],
              //     "DD-MM-YYYY"
              //   ).format("YYYY-MM-DD");
              // } else {
              //   obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
              // }

              obj["Qty"] =
                items.value[i]["ItemQuantity"];
              obj["Brand"] =
                items.value[i]["Brand"] == null ? 0 : items.value[i]["Brand"];
              obj["ModelNumber"] =
                items.value[i]["ModelNumber"] == null
                  ? 0
                  : items.value[i]["ModelNumber"];
              obj["Size"] =
                items.value[i]["Size"] == null ? 0 : items.value[i]["Size"];
              obj["IsApproved"] = 1;
              (obj["IsConsigneeItem"] = items.value[i]["IsConsigneeItem"] || 0),
                (obj["ConsigneeBarCodeNo"] = items.value[i]["BarCodeNo"] || 0);
              obj["RoomId"] = items.value[i]["RoomId"] || 0;
              obj["RackId"] = items.value[i]["RackId"] || 0;
              obj["RowId"] = items.value[i]["RowId"] || 0;
              obj["BoxId"] = items.value[i]["BoxId"] || 0;
              obj["IsFreeItem"] = items.value[i]["IsFreeItem"] || 0;
              (obj["SupplierBarCode"] = items.value[i]["SupplierBarCode"]);

              (obj["UOM"] = items.value[i]["UOM"] || 0);

              (obj["DCType"] = paramnames == "DC" ? requestForm.value.DCType : 0);

              (obj["StockInId"] = items.value[i]["StockInId"] || 0);
              (obj["StockInDetailId"] = items.value[i]["StockInDetailId"] || 0);
              (obj["AssetFlag"] = items.value[i]["Asset"] === true ? 1 : 0);

              (obj["StockWoId"] = items.value[i]["StockWoId"] || 0);
              (obj["StockWoDetailId"] = items.value[i]["StockWoDetailId"] || 0);
              (obj["StockoutId"] = items.value[i]["StockOutId"] || 0);
              (obj["StockoutDetailId"] = items.value[i]["StockOutDetailId"] || 0);

              obj["IsFreeQtyItem"] = items.value[i]["IsFreeQtyItem"] || 0;

              arr[i] = obj;
            }
            requestForm.value.StockInDetailList = arr
            debugger
            debugger
            let result = await StockInService.createStockInDetailsDraft(requestForm.value);
            id = result["result"][0]['Id'];
            requestForm.value.Id = id
            arr = []
            for (let i = 0; i < requestForm.value.StockInDetailList.length; i++) {
              const ResultList = result["result"][0]
              items.value[i].Id = ResultList.StockInDetailList[i]['Id'];
              items.value[i].StockDetailsId = ResultList.StockInDetailList[i]['Id'];
            }
            let Msg = result["result"][0]['SuccessMsg'];
            if (Msg == "Invoice Exists") {
              // loading.value = false;
              toast.add({
                severity: "warn",
                summary: "Invoice Number Already Exists for this Supplier",
                detail: "The invoice number you entered already exists for this supplier. Please provide a unique invoice number.",
                life: 10000,
              });
              requestForm.value.InvoiceNo = "";
              invDetails.value.InvoiceNo = "";
              recieveditems.value = [];
              items.value = [];
              return false;
            }
            if (uploadedTableList.value.length != 0) {
              for (let i = 0; i < uploadedTableList.value.length; i++) {
                let Fileobj = {};
                (Fileobj["Id"] = uploadedTableList.value[i].Id),
                  (Fileobj["DocType"] = requestForm.value.DocType),
                  (Fileobj["RefId"] = result["result"][0]['Id']),
                  (Fileobj["FileName"] = uploadedTableList.value[i].fileName),
                  (Fileobj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
                  (Fileobj["CreatedBy"] = UserId),
                  (Fileobj["ModifiedBy"] = 0),
                  (Fileobj["EntityId"] = Number(Entitydata.value)),
                  (Fileobj["IsApproved"] = 0),
                  FileUploadArray.push(Fileobj)
              }
              StockWOFileUpload.value = FileUploadArray
              let FileUploadResult = await StockInFileUploadServices.insertStockWOFile(StockWOFileUpload.value);
              debugger
              for (let i = 0; i < uploadedTableList.value.length; i++) {
                uploadedTableList.value[i].Id = FileUploadResult["result"][i]['Id'];
              }
            }
          }
        } else {
          // loading.value = false;
          toast.add({
            severity: "warn",
            summary: "Items Required",
            detail: "Please select items before proceeding.",
            life: 3000,
          });
        }
      }
    };

    const ItemDeleteConfirm = (event, data) => {
      confirm.require({
        target: event.currentTarget,
        message: 'Do you want to delete this record?',
        icon: 'pi pi-info-circle',
        rejectClass: 'p-button-secondary p-button-outlined p-button-sm',
        acceptClass: 'p-button-danger p-button-sm',
        rejectLabel: 'Cancel',
        acceptLabel: 'Delete',
        accept: () => {
          IsItemDelete(data)
        },
        reject: () => {
          toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        }
      });
    };

    //Item Delete
    async function IsItemDelete(data) {
      debugger;
      let msg: any = null;
      if ((data.DocType == 19 && (data.DCType == 3 || data.DCType == 4)) || (data.DCType == 1 && data.StockOutId && data.StockOutDetailId)) {
        items.value = items.value.filter((item: any) => item.StockInDetailId !== data.StockInDetailId);
      }
      else {
        if (items.value.length == 1) {
          toast.add({
            severity: "info",
            summary: "Cannot Delete Last Item",
            detail: "You cannot delete the last remaining item.",
            life: 3000,
          });
          return;
        }
        else {

          if (paramnames == "GRN With PO" || (paramnames == "DC" && (requestForm.value.DCType == 2 || requestForm.value.DCType == 3))) {
            if ((data["StockDetailsId"] && data["StockDetailsId"] != 0)) {
              let result = await StockInService.deleteStockInDetails(
                data.StockDetailsId
              );
              msg = result["ErrorInfo"].ErrorCode;
            }
            if (data["IsFreeItem"] == 1) {
              items.value = items.value.filter((x: any) => {
                return !(
                  x.ItemId === data["ItemId"] &&
                  x.Brand === data["Brand"] &&
                  x.ModelNumber === data["ModelNumber"] &&
                  x.Size === data["Size"] &&
                  x.IsFreeItem === data["IsFreeItem"] &&
                  x.BatchNo === data["BatchNo"]
                );
              });
              msg = 1;
            }

            if (data["IsFreeQtyItem"] == 1) {
              items.value = items.value.filter((x: any) => {
                return !(
                  x.ItemId === data["ItemId"] &&
                  x.Brand === data["Brand"] &&
                  x.ModelNumber === data["ModelNumber"] &&
                  x.Size === data["Size"] &&
                  x.IsFreeQtyItem === data["IsFreeQtyItem"] &&
                  x.BatchNo === data["BatchNo"]
                );
              });
              msg = 1;
            }

            if (msg == null) {

              let existingItem = recieveditems.value.find(
                (item) =>
                  item.ItemId === data.ItemId &&
                  item.Brand === data.Brand &&
                  item.ModelNumber === data.ModelNumber &&
                  item.Size === data.Size
              );

              if (existingItem) {
                existingItem.ItemQuantity = Number(existingItem.ItemQuantity) + Number(data.ItemQuantity);
                existingItem.ChkPOQty = data.RequestedQty;
                existingItem.BatchNo = "";
                existingItem.ExpiryDate = "";
                existingItem.ManufactureDate = "";

                existingItem.Rate = Number(existingItem.ItemQuantity * existingItem.UnitRate).toFixed(2);

                let BeforeDiscountRate = existingItem.Rate;

                const discountAmount = ((existingItem.Discount || 0.00) / 100) * existingItem.Rate;
                existingItem.Discountamount = discountAmount.toFixed(2);

                existingItem.Rate = (existingItem.Rate - existingItem.Discountamount || 0.00).toFixed(2);

                existingItem.Purchasetaxamount = (existingItem.Rate * (existingItem.PurchasePercentage / 100)).toFixed(2);

                if (existingItem.SGSTTax && existingItem.CGSTTax) {
                  existingItem.SGSTTaxAmount = Number(Number(existingItem.Purchasetaxamount) / 2).toFixed(2);

                  existingItem.CGSTTaxAmount = Number(Number(existingItem.Purchasetaxamount) / 2).toFixed(2);
                }

                if (existingItem.IGSTTax) {
                  existingItem.IGSTTaxAmount = Number((existingItem.PurchasePercentage * existingItem.Rate) / 100).toFixed(2);
                }

                existingItem.Rate = BeforeDiscountRate;

                existingItem.Totalvalue = Number((Number(existingItem.Rate) - Number(existingItem.Discountamount || 0.00)) + Number(existingItem.Purchasetaxamount) + Number(existingItem.servicecharges || 0.00) + Number(existingItem.othercharges || 0.00)).toFixed(2)

              } else {
                data.BatchNo = "";
                data.ExpiryDate = "";
                data.ExpiryDate1 = "";
                data.ManufactureDt = "";
                data.BatchNo = "";

                recieveditems.value.push(data);
              }

              recieveditemsOrg.value = recieveditems.value.map((item1) => {
                item1.ItemQty1 = item1.ItemQuantity
                item1.ChkPOQty = item1.ItemQuantity
                item1.UnitRate = item1.UnitRate
                item1.MRP = item1.MRP
                return item1
              })


              ListSelect.value = JSON.parse(JSON.stringify(recieveditems.value));

              itemcatfilteroptions.value = ListSelect.value.reduce((acc: any, current) => {
                const { CategoryId, ItemCategory1 }: any = current;
                const existingCategory: any = acc.find(item => item["value"] == CategoryId);
                if (existingCategory) {
                  existingCategory.count++;
                } else {
                  acc.push({ value: CategoryId, name: ItemCategory1 });
                }
                return acc;
              }, []);


              if (recieveditems.value[0].IsServiceLevel == '0') {
                Entitydata.value = 3080
                OperationId = 3080001
              }
              else if (recieveditems.value[0].IsServiceLevel == '1') {
                Entitydata.value = 3081
                OperationId = 3081001
              }
              else if (recieveditems.value[0].IsServiceLevel == '3') {
                Entitydata.value = 3082
                OperationId = 3082001
              }
              else if (recieveditems.value[0].IsServiceLevel == '4') {
                Entitydata.value = 3130
                OperationId = 3130001
              }

              //all item
              commonItemProps.value.fieldType = 1;
              showFields.value.RequestedQty.show = true;

              items.value = items.value.filter((x: any) => {
                return !(
                  x.ItemId === data.ItemId &&
                  x.Brand === data.Brand &&
                  x.ModelNumber === data.ModelNumber &&
                  x.Size === data.Size &&
                  x.BatchNo === data.BatchNo
                );
              });


            }
            else {
              console.log(msg);
            }

          }
          else {
            if (data["StockDetailsId"] && data["StockDetailsId"] != 0) {
              let result = await StockInService.deleteStockInDetails(
                data.StockDetailsId
              );
              msg = result["ErrorInfo"].ErrorCode;
            }

            if (msg == null) {

              items.value = items.value.filter((x: any) => {
                return !(
                  x.ItemId === data.ItemId &&
                  x.Brand === data.Brand &&
                  x.ModelNumber === data.ModelNumber &&
                  x.Size === data.Size &&
                  x.BatchNo === data.BatchNo &&
                  x.IsFreeItem === data.IsFreeItem &&
                  x.IsFreeQtyItem === data.IsFreeQtyItem
                );
              });
            }
            else {
              console.log(msg);
            }
          }
          console.log(items.value);

          if (msg == null || msg == 1) {
            toast.add({ severity: 'info', summary: 'Confirmed', detail: 'Record deleted', life: 3000 });
            return;
          }
          else {
            toast.add({ severity: 'error', summary: 'Error', detail: msg, life: 3000 });
            return;
          }
        }
      }

    }


    function TotalGrossCalc(value1) {
      debugger;
      // let arrCount: any = [];
      // if (nonFilterDatasCopy.length > 0 && paramnames == "GRN With PO") {
      //   arrCount = nonFilterDatasCopy.filter((item) => item.ItemId == value1.ItemId);
      // }
      // if ((arrCount.length > 0 && paramnames == "GRN With PO") || paramnames != "GRN With PO") {

      //   grossvalues.value.grossamount = value1.grossamount;
      //   grossvalues.value.totalqty = value1.totalqty;

      //   grossvalues.value.taxamount =
      //     value1.taxamount +
      //     GRNOverAllChrg.GRNTransportationTax +
      //     GRNOverAllChrg.GRNFreightTax;

      //   grossvalues.value.totaldiscountamount = value1.totaldiscountamount;
      //   grossvalues.value.othercharges = value1.totalothercharges;
      //   grossvalues.value.transportcharges = value1.totaltransportcharges;
      //   grossvalues.value.servicecharges = value1.totalservicecharges;
      //   grossvalues.value.netamount = (value1.netamount).toFixed(2);
      //   //value1.TransportCharges = value1.totaltransportcharges;
      //   GRNOverAllChrg.GRNTransportationCharges = 0;
      //   GRNOverAllChrg.GRNOtherCharges = 0;
      //   GRNOverAllChrg.GRNDiscount = 0;
      //   // GRNOverallAmountCal();
      // }
    }

    function debounce<T extends (...args: any[]) => void>(func: T, wait: number) {
      let timeout: ReturnType<typeof setTimeout>;

      return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }

    const debouncedGRNCalculation = debounce(GRNCalculation, 300);

    let initialCalculationDone = false;

    watch(recieveditems, (newReceivedItems, oldReceivedItems) => {
      debugger;
      if (!initialCalculationDone && recieveditems.value.length > 0) {
        debouncedGRNCalculation();

        initialCalculationDone = true;
      }
    }, { deep: true });

    watch(items, (newItems, oldItems) => {
      debugger;
      if (items.value.length > 0) {
        debouncedGRNCalculation();
      }
    }, { deep: true });

    watch(DataObj, (newItems, oldItems) => {
      debugger;
      if (DataObj.value.ReturnOptions.length > 0) {
        if (routes.query.Id != "" && routes.query.Id != undefined) {
          GetByGrn(DataObj.value.ReturnOptions[0])
        }
      }
    }, { deep: true });


    async function GRNCalculation() {
      debugger;
      await GRNCalcDetailsClear();

      if (items.value.length == 0) {

        const itemsToCalculate = SelectList.value.length > 0 ? SelectList.value : recieveditems.value;

        for (let i = 0; i < itemsToCalculate.length; i++) {
          grossvalues.value.grossamount += parseFloat(itemsToCalculate[i]["Rate"] || 0.00);
          grossvalues.value.totaldiscountamount += parseFloat(itemsToCalculate[i]["Discountamount"] || 0.00);
          grossvalues.value.taxamount += parseFloat(itemsToCalculate[i]["Purchasetaxamount"]);
          grossvalues.value.servicecharges += parseFloat(itemsToCalculate[i]["servicecharges"] || 0.00);
          grossvalues.value.othercharges += parseFloat(itemsToCalculate[i]["othercharges"] || 0.00);
          grossvalues.value.sgsttaxamount += parseFloat(itemsToCalculate[i]["SGSTTaxAmount"]);
          grossvalues.value.cgsttaxamount += parseFloat(itemsToCalculate[i]["CGSTTaxAmount"]);
          grossvalues.value.igsttaxamount += parseFloat(itemsToCalculate[i]["IGSTTaxAmount"]);
          grossvalues.value.totalqty += parseFloat(itemsToCalculate[i]["ItemQuantity"] || 0);
        }
      }
      else {

        for (let i = 0; i < items.value.length; i++) {
          if (items.value[i]["IsFreeItem"] == 0) {
            if (paramnames == "GRN With PO" && items.value[i]["StockDetailsId"] != 0) {

              grossvalues.value.grossamount += parseFloat(items.value[i]["Rate"]);

              grossvalues.value.totaldiscountamount += parseFloat(items.value[i]["Discountamount"] || 0.00);

              grossvalues.value.taxamount += parseFloat(items.value[i]["Purchasetaxamount"]);

              grossvalues.value.servicecharges += parseFloat(items.value[i]["servicecharges"] || 0.00);

              grossvalues.value.othercharges += parseFloat(items.value[i]["othercharges"] || 0.00);

              grossvalues.value.sgsttaxamount += parseFloat(items.value[i]["SGSTTaxAmount"]);
              grossvalues.value.cgsttaxamount += parseFloat(items.value[i]["CGSTTaxAmount"]);
              grossvalues.value.igsttaxamount += parseFloat(items.value[i]["IGSTTaxAmount"]);

              grossvalues.value.totalqty += parseFloat(items.value[i]["ItemQuantity"] || 0);

            }
            else if (paramnames != "GRN With PO") {
              grossvalues.value.grossamount += parseFloat(items.value[i]["Rate"]);

              grossvalues.value.totaldiscountamount += parseFloat(items.value[i]["Discountamount"] || 0.00);

              grossvalues.value.taxamount += parseFloat(items.value[i]["Purchasetaxamount"]);

              grossvalues.value.servicecharges += parseFloat(items.value[i]["servicecharges"] || 0.00);

              grossvalues.value.othercharges += parseFloat(items.value[i]["othercharges"] || 0.00);

              grossvalues.value.sgsttaxamount += parseFloat(items.value[i]["SGSTTaxAmount"]);
              grossvalues.value.cgsttaxamount += parseFloat(items.value[i]["CGSTTaxAmount"]);
              grossvalues.value.igsttaxamount += parseFloat(items.value[i]["IGSTTaxAmount"]);

              grossvalues.value.totalqty += parseFloat(items.value[i]["ItemQuantity"] || 0);
            }
          }
          ItemDiscountAmountCalculation(items.value[i])
        }
      }

      grossvalues.value.grossamount = Number(grossvalues.value.grossamount).toFixed(2);

      grossvalues.value.totaldiscountamount = Number(Number(requestForm.value.GRNDiscount || 0.00) + Number(grossvalues.value.totaldiscountamount || 0.00)).toFixed(2);

      grossvalues.value.taxamount = Number(grossvalues.value.taxamount).toFixed(2);

      grossvalues.value.servicecharges = Number(grossvalues.value.servicecharges || 0.00).toFixed(2);

      grossvalues.value.othercharges = Number(Number(requestForm.value.GRNOtherCharges || 0.00) + Number(grossvalues.value.othercharges || 0.00)).toFixed(2);

      grossvalues.value.sgsttaxamount = Number(grossvalues.value.sgsttaxamount).toFixed(2);
      grossvalues.value.cgsttaxamount = Number(grossvalues.value.cgsttaxamount).toFixed(2);
      grossvalues.value.igsttaxamount = Number(grossvalues.value.igsttaxamount).toFixed(2);

      await GRNSubcalculation(0);

      if (paramnames == "GRN With PO") {
        if (items.value.length == 0) {
          taxCalculation(recieveditems.value)
        }
        else {
          taxCalculation(items.value)
        }
      }
      else {
        taxCalculation(items.value)
      }
    };

    const GRNSubcalculation = async (value) => {
      debugger;
      grossvalues.value.netamount = ((Number(grossvalues.value.grossamount) - Number(grossvalues.value.totaldiscountamount || 0.00)) + (Number(grossvalues.value.taxamount) + Number(grossvalues.value.transportcharges || 0.00) + Number(grossvalues.value.freightcharges || 0.00) + Number(grossvalues.value.servicecharges || 0.00) + Number(grossvalues.value.othercharges || 0.00) + Number(requestForm.value.RoundOff || 0.00))).toFixed(2)
      OriginalPoAmount.value = grossvalues.value.netamount;

      if (value == 0) {
        CopyTransportationTaxAmount = "0.00";
        CopyFreightTaxAmount = "0.00";
      }
      await TransportTaxOnChange();
      await FreightTaxOnChange();

      if (roundoffHiddenValue.value == true) {
        POandDCvalue.value = OriginalPoAmount.value;
      }
    }

    function GRNCalcDetailsClear() {
      debugger;
      grossvalues.value.grossamount = 0.00;
      grossvalues.value.totaldiscountamount = 0.00;
      grossvalues.value.taxamount = 0.00;
      grossvalues.value.servicecharges = 0.00;
      grossvalues.value.othercharges = 0.00;
      grossvalues.value.sgsttaxamount = 0.00;
      grossvalues.value.cgsttaxamount = 0.00;
      grossvalues.value.igsttaxamount = 0.00;
      grossvalues.value.netamount = 0.00;
      grossvalues.value.totalqty = 0;
    }

    async function TransportAmountOnChange() {
      debugger;
      grossvalues.value.transportcharges = Number(requestForm.value.GRNTransportationCharges || 0.00).toFixed(2)
      await GRNSubcalculation(1);
      TransportTaxOnChange();
    }

    let CopyTransportationTaxAmount = "0.00";
    function TransportTaxOnChange() {
      debugger;
      let transportationTaxAmount = Number((Number(requestForm.value.GRNTransportationTax || 0.00) / 100) * Number(requestForm.value.GRNTransportationCharges || 0.00)).toFixed(2);
      let freightTaxAmount = Number((Number(requestForm.value.GRNFreightTax || 0.00) / 100) * Number(requestForm.value.GRNFreightCharges || 0.00)).toFixed(2);

      grossvalues.value.taxamount = Number((Number(grossvalues.value.taxamount || 0.00) - Number(CopyTransportationTaxAmount || 0.00)) + Number(transportationTaxAmount || 0.00)).toFixed(2);

      let sgsttaxamount = 0.00;
      let cgsttaxamount = 0.00;
      let igsttaxamount = 0.00;
      if (items.value.length == 0) {
        for (let i = 0; i < recieveditems.value.length; i++) {
          sgsttaxamount += parseFloat(recieveditems.value[i]["SGSTTaxAmount"]);
          cgsttaxamount += parseFloat(recieveditems.value[i]["CGSTTaxAmount"]);
          igsttaxamount += parseFloat(recieveditems.value[i]["IGSTTaxAmount"]);
        }
      }
      else {
        for (let i = 0; i < items.value.length; i++) {
          sgsttaxamount += parseFloat(items.value[i]["SGSTTaxAmount"]);
          cgsttaxamount += parseFloat(items.value[i]["CGSTTaxAmount"]);
          igsttaxamount += parseFloat(items.value[i]["IGSTTaxAmount"]);
        }

      }


      if (session.BranchStateId != commonItemProps.value.SupllierStateId) {
        grossvalues.value.sgsttaxamount = Number(Number(sgsttaxamount || 0.00) + Number(0.00)).toFixed(2);
        grossvalues.value.cgsttaxamount = Number(Number(cgsttaxamount || 0.00) + Number(0.00)).toFixed(2);
        grossvalues.value.igsttaxamount = Number(Number(igsttaxamount || 0.00) + Number(Number(freightTaxAmount || 0.00) / 2) + Number(transportationTaxAmount || 0.00)).toFixed(2);
      }
      else {
        grossvalues.value.sgsttaxamount = Number(Number(sgsttaxamount || 0.00) + Number(Number(freightTaxAmount || 0.00) / 2) + Number(Number(transportationTaxAmount || 0.00) / 2)).toFixed(2);
        grossvalues.value.cgsttaxamount = Number(Number(cgsttaxamount || 0.00) + Number(Number(freightTaxAmount || 0.00) / 2) + Number(Number(transportationTaxAmount || 0.00) / 2)).toFixed(2);
        grossvalues.value.igsttaxamount = Number(Number(igsttaxamount || 0.00) + Number(0.00)).toFixed(2);
      }

      CopyTransportationTaxAmount = transportationTaxAmount;

      grossvalues.value.netamount = ((Number(grossvalues.value.grossamount) - Number(grossvalues.value.totaldiscountamount || 0.00)) + (Number(grossvalues.value.taxamount) + Number(grossvalues.value.transportcharges || 0.00) + Number(grossvalues.value.freightcharges || 0.00) + Number(grossvalues.value.servicecharges || 0.00) + Number(grossvalues.value.othercharges || 0.00) + Number(requestForm.value.RoundOff || 0.00))).toFixed(2)
    }

    async function FreightAmountOnChange() {
      debugger;
      grossvalues.value.freightcharges = Number(requestForm.value.GRNFreightCharges || 0.00).toFixed(2)
      await GRNSubcalculation(1);
      FreightTaxOnChange()
    }

    let CopyFreightTaxAmount = "0.00";
    function FreightTaxOnChange() {
      debugger;

      let transportationTaxAmount = Number((Number(requestForm.value.GRNTransportationTax || 0.00) / 100) * Number(requestForm.value.GRNTransportationCharges || 0.00)).toFixed(2);
      let freightTaxAmount = Number((Number(requestForm.value.GRNFreightTax || 0.00) / 100) * Number(requestForm.value.GRNFreightCharges || 0.00)).toFixed(2);

      grossvalues.value.taxamount = Number((Number(grossvalues.value.taxamount || 0.00) - Number(CopyFreightTaxAmount || 0.00)) + Number(freightTaxAmount || 0.00)).toFixed(2);

      let sgsttaxamount = 0.00;
      let cgsttaxamount = 0.00;
      let igsttaxamount = 0.00;
      if (items.value.length == 0) {
        for (let i = 0; i < recieveditems.value.length; i++) {
          sgsttaxamount += parseFloat(recieveditems.value[i]["SGSTTaxAmount"]);
          cgsttaxamount += parseFloat(recieveditems.value[i]["CGSTTaxAmount"]);
          igsttaxamount += parseFloat(recieveditems.value[i]["IGSTTaxAmount"]);
        }
      }
      else {
        for (let i = 0; i < items.value.length; i++) {
          sgsttaxamount += parseFloat(items.value[i]["SGSTTaxAmount"]);
          cgsttaxamount += parseFloat(items.value[i]["CGSTTaxAmount"]);
          igsttaxamount += parseFloat(items.value[i]["IGSTTaxAmount"]);
        }

      }


      if (session.BranchStateId != commonItemProps.value.SupllierStateId) {
        grossvalues.value.sgsttaxamount = Number(Number(sgsttaxamount || 0.00) + Number(0.00)).toFixed(2);
        grossvalues.value.cgsttaxamount = Number(Number(cgsttaxamount || 0.00) + Number(0.00)).toFixed(2);
        grossvalues.value.igsttaxamount = Number(Number(igsttaxamount || 0.00) + Number(freightTaxAmount || 0.00) + Number(Number(transportationTaxAmount || 0.00) / 2)).toFixed(2);
      }
      else {
        grossvalues.value.sgsttaxamount = Number(Number(sgsttaxamount || 0.00) + Number(Number(freightTaxAmount || 0.00) / 2) + Number(Number(transportationTaxAmount || 0.00) / 2)).toFixed(2);
        grossvalues.value.cgsttaxamount = Number(Number(cgsttaxamount || 0.00) + Number(Number(freightTaxAmount || 0.00) / 2) + Number(Number(transportationTaxAmount || 0.00) / 2)).toFixed(2);
        grossvalues.value.igsttaxamount = Number(Number(igsttaxamount || 0.00) + Number(0.00)).toFixed(2);
      }

      CopyFreightTaxAmount = freightTaxAmount;

      grossvalues.value.netamount = ((Number(grossvalues.value.grossamount) - Number(grossvalues.value.totaldiscountamount || 0.00)) + (Number(grossvalues.value.taxamount) + Number(grossvalues.value.transportcharges || 0.00) + Number(grossvalues.value.freightcharges || 0.00) + Number(grossvalues.value.servicecharges || 0.00) + Number(grossvalues.value.othercharges || 0.00) + Number(requestForm.value.RoundOff || 0.00))).toFixed(2)
    }

    function OverallOtherChargesOnChange() {
      debugger;

      grossvalues.value.othercharges = 0.00;

      for (let i = 0; i < items.value.length; i++) {
        grossvalues.value.othercharges += parseFloat(items.value[i]["othercharges"]);
      }

      grossvalues.value.othercharges = Number(Number(grossvalues.value.othercharges || 0.00) + Number(requestForm.value.GRNOtherCharges || 0.00)).toFixed(2);

      GRNSubcalculation(1);
    }

    function OverAllDiscountAmountOnChange() {
      debugger;
      grossvalues.value.totaldiscountamount = 0.00;

      for (let i = 0; i < items.value.length; i++) {
        grossvalues.value.totaldiscountamount += parseFloat(items.value[i]["Discountamount"]);
      }

      grossvalues.value.totaldiscountamount = Number(Number(grossvalues.value.totaldiscountamount || 0.00) + Number(requestForm.value.GRNDiscount || 0.00)).toFixed(2);

      GRNSubcalculation(1);
    }

    function ItemQtyOnChange(data) {
      debugger;

      if (data.ItemQuantity === '') {
        return;
      }

      if (isNaN(data.ItemQuantity) || Number(data.ItemQuantity) <= 0) {
        toast.add({
          severity: "warn",
          summary: "Invalid Quantity",
          detail: "Quantity must be a positive number greater than zero.",
          life: 3000,
        });
        data.ItemQuantity = "1";
        return;
      }

      if (paramnames == "GRN With PO" && Number(data.ItemQuantity) > (data.DCType == 0 ? Number(data.ChkPOQty) : Number(data.DCQuantity))) {
        toast.add({
          severity: "warn",
          summary: "Quantity Exceeds Limit",
          detail: "The quantity you entered exceeds the requested quantity. It has been adjusted to match the requested quantity.",
          life: 3000,
        });

        data.ItemQuantity = data.DCType == 0 ? data.ChkPOQty : data.DCQuantity;

        if (data.PurchaseUnit == data.UOM) {
          data.Rate = Number(data.ItemQuantity * data.ConversionFactor * data.UnitRate).toFixed(2);
        }
        else {
          data.Rate = Number(data.ItemQuantity * data.UnitRate).toFixed(2);
        }

        let BeforeDiscountRate = data.Rate;
        const discountAmount = ((data.Discount || 0.00) / 100) * data.Rate;
        data.Discountamount = discountAmount.toFixed(2);

        data.Rate = (data.Rate - data.Discountamount).toFixed(2);

        data.Purchasetaxamount = (data.Rate * (data.PurchasePercentage / 100)).toFixed(2);

        if (data.SGSTTax && data.CGSTTax) {
          data.SGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);

          data.CGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);
        }

        if (data.IGSTTax) {
          data.IGSTTaxAmount = Number((data.PurchasePercentage * data.Rate) / 100).toFixed(2);
        }

        data.Rate = BeforeDiscountRate;

        data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)

        return false;
      }
      else if (paramnames == "GRN Without PO" && DCNoDropdownLength.value != 0 && Number(data.ItemQuantity) > Number(data.DCQuantity)) {
        toast.add({
          severity: "warn",
          summary: "Quantity Exceeds Limit",
          detail: "The quantity you entered exceeds the DC quantity. It has been adjusted to match the DC quantity.",
          life: 3000,
        });

        data.ItemQuantity = data.DCQuantity;

        if (data.PurchaseUnit == data.UOM) {
          data.Rate = Number(data.ItemQuantity * data.ConversionFactor * data.UnitRate).toFixed(2);
        }
        else {
          data.Rate = Number(data.ItemQuantity * data.UnitRate).toFixed(2);
        }

        let BeforeDiscountRate = data.Rate;
        const discountAmount = ((data.Discount || 0.00) / 100) * data.Rate;
        data.Discountamount = discountAmount.toFixed(2);

        data.Rate = (data.Rate - data.Discountamount).toFixed(2);

        data.Purchasetaxamount = (data.Rate * (data.PurchasePercentage / 100)).toFixed(2);

        if (data.SGSTTax && data.CGSTTax) {
          data.SGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);

          data.CGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);
        }

        if (data.IGSTTax) {
          data.IGSTTaxAmount = Number((data.PurchasePercentage * data.Rate) / 100).toFixed(2);
        }

        data.Rate = BeforeDiscountRate;

        data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)

        return false;
      }
      else if (paramnames == "DC" && requestForm.value.DCType == 2 && Number(data.ItemQuantity) > Number(data.IssuedQty)) {
        toast.add({
          severity: "warn",
          summary: "Quantity Exceeds Limit",
          detail: "The quantity you entered exceeds the Return quantity. It has been adjusted to match the Return quantity.",
          life: 3000,
        });
        data.ItemQuantity = data.IssuedQty

        if (data.PurchaseUnit == data.UOM) {
          data.Rate = Number(data.ItemQuantity * data.ConversionFactor * data.UnitRate).toFixed(2);
        }
        else {
          data.Rate = Number(data.ItemQuantity * data.UnitRate).toFixed(2);
        }

        let BeforeDiscountRate = data.Rate;
        const discountAmount = ((data.Discount || 0.00) / 100) * data.Rate;
        data.Discountamount = discountAmount.toFixed(2);

        data.Rate = (data.Rate - data.Discountamount).toFixed(2);

        data.Purchasetaxamount = (data.Rate * (data.PurchasePercentage / 100)).toFixed(2);

        if (data.SGSTTax && data.CGSTTax) {
          data.SGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);

          data.CGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);
        }

        if (data.IGSTTax) {
          data.IGSTTaxAmount = Number((data.PurchasePercentage * data.Rate) / 100).toFixed(2);
        }
        data.Rate = BeforeDiscountRate;
        data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)
        return false;
      }
      else if (paramnames == "DC" && requestForm.value.DCType == 3 && Number(data.ItemQuantity) > Number(data.RequestedQty)) {
        toast.add({
          severity: "warn",
          summary: "Quantity Exceeds Limit",
          detail: "The quantity you entered exceeds the PO quantity. It has been adjusted to match the PO quantity.",
          life: 3000,
        });
        data.ItemQuantity = data.RequestedQty

        if (data.PurchaseUnit == data.UOM) {
          data.Rate = Number(data.ItemQuantity * data.ConversionFactor * data.UnitRate).toFixed(2);
        }
        else {
          data.Rate = Number(data.ItemQuantity * data.UnitRate).toFixed(2);
        }

        let BeforeDiscountRate = data.Rate;
        const discountAmount = ((data.Discount || 0.00) / 100) * data.Rate;
        data.Discountamount = discountAmount.toFixed(2);

        data.Rate = (data.Rate - data.Discountamount).toFixed(2);

        data.Purchasetaxamount = (data.Rate * (data.PurchasePercentage / 100)).toFixed(2);

        if (data.SGSTTax && data.CGSTTax) {
          data.SGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);

          data.CGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);
        }

        if (data.IGSTTax) {
          data.IGSTTaxAmount = Number((data.PurchasePercentage * data.Rate) / 100).toFixed(2);
        }
        data.Rate = BeforeDiscountRate;
        data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)
        return false;
      }
      else {
        debugger;
        if (data.PurchaseUnit == data.UOM) {
          data.Rate = Number(data.ItemQuantity * data.ConversionFactor * data.UnitRate).toFixed(2);
        }
        else {
          data.Rate = Number(data.ItemQuantity * data.UnitRate).toFixed(2);
        }

        let BeforeDiscountRate = data.Rate;

        const discountAmount = ((data.Discount || 0.00) / 100) * data.Rate;
        data.Discountamount = discountAmount.toFixed(2);

        data.Rate = (data.Rate - data.Discountamount).toFixed(2);

        data.Purchasetaxamount = (data.Rate * (data.PurchasePercentage / 100)).toFixed(2);

        if (data.SGSTTax && data.CGSTTax) {
          data.SGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);

          data.CGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);
        }

        if (data.IGSTTax) {
          data.IGSTTaxAmount = Number((data.PurchasePercentage * data.Rate) / 100).toFixed(2);
        }

        data.Rate = BeforeDiscountRate;

        data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)
      }

      CopyTransportationTaxAmount = "0.00";
      CopyFreightTaxAmount = "0.00";
    }

    function ItemUnitRateOnChange(data) {
      debugger;
      data.Rate = Number(data.ItemQuantity * data.UnitRate).toFixed(2);
      let BeforeDiscountRate = data.Rate;

      const discountAmount = ((data.Discount || 0.00) / 100) * data.Rate;
      data.Discountamount = discountAmount.toFixed(2);

      data.Rate = (data.Rate - data.Discountamount).toFixed(2);

      data.Purchasetaxamount = (data.Rate * (data.PurchasePercentage / 100)).toFixed(2);

      if (data.SGSTTax && data.CGSTTax) {
        data.SGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);

        data.CGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);
      }

      if (data.IGSTTax) {
        data.IGSTTaxAmount = Number((data.PurchasePercentage * data.Rate) / 100).toFixed(2);
      }

      data.Rate = BeforeDiscountRate;

      data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)
      CopyTransportationTaxAmount = "0.00";
      CopyFreightTaxAmount = "0.00";
    }

    function ItemDiscountAmountCalculation(data) {
      debugger;

      let BeforeDiscountRate = data.Rate;

      const discountAmount = ((data.Discount || 0.00) / 100) * data.Rate;
      data.Discountamount = discountAmount.toFixed(2);

      data.Rate = (data.Rate - data.Discountamount).toFixed(2);

      data.Purchasetaxamount = (data.Rate * (data.PurchasePercentage / 100)).toFixed(2);

      if (data.SGSTTax && data.CGSTTax) {
        data.SGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);

        data.CGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);
      }

      if (data.IGSTTax) {
        data.IGSTTaxAmount = Number((data.PurchasePercentage * data.Rate) / 100).toFixed(2);
      }

      data.Rate = BeforeDiscountRate;

      data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)
      CopyTransportationTaxAmount = "0.00";
      CopyFreightTaxAmount = "0.00";
    }

    function ItemDiscountPercentageCalculation(data) {
      debugger;
      let BeforeDiscountRate = data.Rate;

      const discountPercentage = ((data.Discountamount || 0.00) / data.Rate) * 100;
      data.Discount = discountPercentage.toFixed(2);

      data.Rate = (data.Rate - data.Discountamount).toFixed(2);

      data.Purchasetaxamount = (data.Rate * (data.PurchasePercentage / 100)).toFixed(2);

      if (data.SGSTTax && data.CGSTTax) {
        data.SGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);

        data.CGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);
      }

      if (data.IGSTTax) {
        data.IGSTTaxAmount = Number((data.PurchasePercentage * data.Rate) / 100).toFixed(2);
      }

      data.Rate = BeforeDiscountRate;

      data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)
      CopyTransportationTaxAmount = "0.00";
      CopyFreightTaxAmount = "0.00";
    }

    function ItemServiceChargesOnChange(data) {
      debugger;
      data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)
      CopyTransportationTaxAmount = "0.00";
      CopyFreightTaxAmount = "0.00";
    }

    function ItemOtherChargesOnChange(data) {
      debugger;
      data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)
      CopyTransportationTaxAmount = "0.00";
      CopyFreightTaxAmount = "0.00";
    }


    let roundoffHiddenValue = ref(false);
    let POandDCvalue = ref(0.00);
    async function getPoItems(value) {
      debugger;

      if (paramnames == "GRN Without PO" && value._rawValue[0]?.DCType == 4) {
        if (value._rawValue.length === 0) {
          items.value.length = 0;
        } else {
          items.value.length = 0;
          items.value = value._rawValue;
        }
      }
      else {
        if (EditId.value == undefined || requestForm.value.IsDraft == 1) {
          initialCalculationDone = false

          value._rawValue = value._rawValue.filter((index) => index.ItemQuantity != 0)
          if (value._rawValue.length > 0) {
            OriginalPoAmount.value = value._rawValue[0].grossamount || 0.00;
            requestForm.value.GRNTransportationCharges =
              value._rawValue[0].TransportCharges || 0.00;
            requestForm.value.GRNFreightCharges = value._rawValue[0].Freightcharges || 0.00;
            requestForm.value.GRNOtherCharges = value._rawValue[0].OtherCharges || 0.00;
            requestForm.value.GRNDiscount = value._rawValue[0].DiscountAmount || 0.00;
            await TransportAmountOnChange()
            await FreightAmountOnChange()
            await OverallOtherChargesOnChange()
            await OverAllDiscountAmountOnChange()
            requestForm.value.FromStoreBranchId = value._rawValue[0].FromStoreBranchId;
            requestForm.value.ToStoreBranchId = value._rawValue[0].ToStoreBranchId;
            requestForm.value.FromStore = value._rawValue[0].FromStore;
            requestForm.value.FromStoreBrMapId = value._rawValue[0].FromStoreBrMapId;
            requestForm.value.ToStore = value._rawValue[0].ToStore;
            requestForm.value.ToStoreBrMapId = value._rawValue[0].ToStoreBrMapId;
            nonFilterDatas.value = value._rawValue;
            // nonFilterDatasCopy = JSON.parse(JSON.stringify(nonFilterDatas.value));
            debugger;

            if (EditId.value == undefined) {
              recieveditems.value = value._rawValue
            } else {

              recieveditems.value = value._rawValue.filter((rawItem) => {
                const matchingItem = items.value.find((item) =>
                  item.Brand === rawItem.Brand &&
                  item.Size === rawItem.Size &&
                  item.ModelNumber === rawItem.ModelNumber &&
                  item.ItemId === rawItem.ItemId &&
                  item.DCType === rawItem.DCType
                );
                if (!matchingItem) {
                  return true;
                }
                return rawItem.ItemQuantity !== 0;
              });
            }

            recieveditemsOrg.value = recieveditems.value.map((item1) => {
              item1.ItemQty1 = item1.ItemQuantity
              item1.ChkPOQty = item1.ItemQuantity
              item1.UnitRate = parseFloat(item1.UnitRate).toFixed(2) || 0.00;
              item1.Rate = parseFloat(item1.Rate).toFixed(2) || 0.00
              item1.MRP = parseFloat(item1.MRP).toFixed(2) || 0.00
              item1.Discount = parseFloat(item1.ItemDiscount).toFixed(2) || 0.00;
              item1.Discountamount = parseFloat(item1.ItemDiscountAmount).toFixed(2) || 0.00;
              return item1
            })

            ListSelect.value = JSON.parse(JSON.stringify(value._rawValue));

            itemcatfilteroptions.value = ListSelect.value.reduce((acc: any, current) => {
              const { CategoryId, ItemCategory1 }: any = current;
              const existingCategory: any = acc.find(item => item["value"] == CategoryId);
              if (existingCategory) {
                existingCategory.count++;
              } else {
                acc.push({ value: CategoryId, name: ItemCategory1 });
              }
              return acc;
            }, []);


            if (paramnames != "DC") {
              if (recieveditems.value[0].IsServiceLevel == '0') {
                Entitydata.value = 3080
                OperationId = 3080001
              }
              else if (recieveditems.value[0].IsServiceLevel == '1') {
                Entitydata.value = 3081
                OperationId = 3081001
              }
              else if (recieveditems.value[0].IsServiceLevel == '3') {
                Entitydata.value = 3082
                OperationId = 3082001
              }
              else if (recieveditems.value[0].IsServiceLevel == '4') {
                Entitydata.value = 3130
                OperationId = 3130001
              }
              else if (recieveditems.value[0].IsServiceLevel == '5') {
                Entitydata.value = 3132
                OperationId = 3132001
              }
            }

            commonItemProps.value.fieldType = 1;
            showFields.value.RequestedQty.show = true;
            for (let i = 0; i < recieveditems.value.length; i++) {
              recieveditems.value[i].PoQty = recieveditems.value[i].DCType == 0 ? recieveditems.value[i].ItemQuantity : 0;
              recieveditems.value[i].DCQuantity = recieveditems.value[i].DCType != 0 ? recieveditems.value[i].ItemQuantity : 0;
            }
          }
          else {
            recieveditems.value.length = 0;
            // if (items.value.length == 1) {
            //   items.value.length = 0;
            // }
          }
        }

        if (paramnames == "GRN With PO") {
          roundoffHiddenValue.value = true;
        }
      }

      if (value._rawValue.length > 0) {
        uploadedTableList.value = uploadedTableList.value.filter((items) => !items.POFileFlag == true)
        const FileUploadresult = await StockWOFileUploadServices.getStockWOFileById(
          value._rawValue[0]?.StockWOTransId
        );

        if (FileUploadresult['result'].length > 0) {
          for (let i = 0; i < FileUploadresult['result'].length; i++) {
            let Fileobj = {};
            (Fileobj["url"] = FileUploadresult['result'][i].FileName.split('/FileUpload/')[1]),
              (Fileobj["fileName"] = FileUploadresult['result'][i].FileName.split('/').pop()),
              (Fileobj["fileType"] = Fileobj["url"].split('/')[0]),
              (Fileobj["fullPath"] = FileUploadresult['result'][i].FileName),
              (Fileobj["Id"] = FileUploadresult['result'][i].Id),
              (Fileobj["POFileFlag"] = true),
              uploadedTableList.value.push(Fileobj)
          }
        }
      }

    }

    //Edit
    async function IsEdit() {
      debugger;

      let result = await StockInService.getlistById(EditId.value);

      if (IsGRNApproval.value.IsApproval == 1) {
        // Update the route query parameter to change the param value
        router.replace({ query: { ...route.query, param: result["result"][0]["DocType"] == 7 ? "GRN With PO" : result["result"][0]["DocType"] == 8 ? "GRN Without PO" : "DC" } });
        commonProps.value.storeId = result["result"][0]["StoreId"];
        ParamValues.value.StoreId = result["result"][0]["StoreId"];
        IsGRNApproval.value.BranchId = result["result"][0]["BranchId"];
        debugger;

        // Check for items with expiry date below 120 days

        if (result["result"][0]["IsApproved"] == 0) {

          const today = new Date();
          const itemsWithShortExpiry = result["result"].filter(item => {
            if (item.ExpiryDtRequired && item.ExpiryDate) {
              const [day, month, year] = item.ExpiryDate.split('-').map(Number);
              const expiryDate = new Date(year, month - 1, day);
              const diffInDays = (expiryDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24);
              return diffInDays < 120;
            }
            return false;
          });

          if (itemsWithShortExpiry.length > 0) {

            const alertMessage = itemsWithShortExpiry
              .map(item => {
                let message = `Item: ${item.Itemname1}`;
                if (item.BatchNo) {
                  message += ` -> Batch no: ${item.BatchNo}`;
                }
                message += ` -> Expiry Date: ${item.ExpiryDate}`;
                return message;
              })
              .join("\n\n");

            toast.add({
              severity: "info",
              summary: "Items with Short Expiry",
              detail: alertMessage,
              life: 0, // Keeps the toast open until manually closed
            });
          }
        }

      }

      console.log(result);
      result = result["result"].map((i1) => {
        i1.InvoiceDate = moment(i1.InvoiceDate, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
        i1.CreatedAt = moment(i1.CreatedAt, "DD-MM-YYYY").format("YYYY-MM-DD");
        i1.InwardDate = moment(i1.InwardDate, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
        i1.DocDate = moment(i1.DocDate, "DD-MM-YYYY").format("YYYY-MM-DD");
        i1.DcDate = moment(i1.DcDate, "DD-MM-YYYY").format("YYYY-MM-DD");

        i1.ChkPOQty = i1.RequestedQty;


        if (i1.ExpiryDate == '01-01-1900') {
          i1.ExpiryDate = "";
          i1.ExpiryDate1 = "";
        }
        else {
          i1.ExpiryDate = i1.ExpiryDate;
          i1.ExpiryDate1 = i1.ExpiryDate;
        }

        if (i1.ManufactureDate == '01-01-1900') {
          i1.ManufactureDate = "";
        }
        else {
          i1.ManufactureDate = i1.ManufactureDate;
        }

        return i1;
      });

      PurchaseformData.value.SupplierId = result[0]["SupplierId"];

      Entitydata.value = result[0]["EntityId"];

      if (Entitydata.value == 3080) {
        OperationId = 3080001
      }
      else if (Entitydata.value == 3081) {
        OperationId = 3081001
      }
      else if (Entitydata.value == 3082) {
        OperationId = 3082001
      }
      else if (Entitydata.value == 3130) {
        OperationId = 3130001
      }

      Object.keys(invDetails.value).forEach((key) => {

        // alert([key])
        // alert(result[0][key])

        if (result[0][key]) {
          if (key == "InvoiceDate" && result[0][key] == "1900-01-01") {
            invDetails.value[key] = "";
          }
          else {
            invDetails.value[key] = result[0][key];

          }

        }
      });
      items.value = result;
      items.value = items.value.map(item => {
        return { ...item, DispensingName: item.SalesUnitName };
      });

      Object.keys(requestForm.value).forEach((key) => {

        if (result[0][key]) requestForm.value[key] = result[0][key];
      });

      Object.keys(grossvalues.value).forEach((key) => {
        if (result[0][key]) grossvalues.value[key] = result[0][key];
      });

      Object.keys(BarCodeItem.value).forEach((key) => {
        if (result[0][key]) BarCodeItem.value[key] = result[0][key];
      });
      if (paramnames == "DC" && requestForm.value.DCType == 2) {
        DataObj.value.ReturnId = result[0]["RefMASNo"];
        requestForm.value.RefNo = result[0]["RefMASNo"];
        LoadGRNReturn()
      }
      else {
        RefIdByMas.value = result[0]["RefIdByMas"];
      }

      // taxCalculation(items.value)

      PurchaseformData.value.purchaseId = result[0]["RefIdByMas"];
      PurchaseformData.value.purchaseName = result[0]["RefMASNo"];
      PurchaseformData.value.purchase = result[0]["RefMASNo"];
      PurchaseformData.value.CreatedAt = result[0]["CreatedAt"];

      PurchaseformData.value.disabled = true;

      requestForm.value.GRNTransportationCharges = result[0]['totaltransportcharges'] || 0.00;

      requestForm.value.GRNFreightCharges = result[0]['GRNFreightCharges'] || 0.00;;
      // requestForm.value.GRNOtherCharges = result[0]['totalothercharges'] || 0.00;
      requestForm.value.GRNOtherCharges = result[0]['GRNOtherCharges'] || 0.00;
      requestForm.value.GRNDiscount = result[0]['GRNDiscount'] || 0.00;

      requestForm.value.GRNTransportationTax = result[0]['GRNTransportationTax'] || 0.00;
      requestForm.value.GRNFreightTax = result[0]['GRNFreightTax'] || 0.00;

      await TransportAmountOnChange();
      await FreightAmountOnChange();

      await OverallOtherChargesOnChange();
      await OverAllDiscountAmountOnChange();

      const FileUploadresult = await StockInFileUploadServices.getStockInFileById(
        EditId.value
      );
      if (FileUploadresult['result'].length > 0) {
        for (let i = 0; i < FileUploadresult['result'].length; i++) {
          let Fileobj = {};
          (Fileobj["url"] = FileUploadresult['result'][i].FileName.split('/FileUpload/')[1]),
            (Fileobj["fileName"] = FileUploadresult['result'][i].FileName.split('/').pop()),
            (Fileobj["fileType"] = Fileobj["url"].split('/')[0]),
            (Fileobj["fullPath"] = FileUploadresult['result'][i].FileName),
            (Fileobj["Id"] = FileUploadresult['result'][i].Id),
            uploadedTableList.value.push(Fileobj)
        }
      }

      if (requestForm.value.IsDraft == 1) {
        if (paramnames == "GRN With PO") {
          SupplierDropDownDisable.value = false;
          RoundOffDisable.value = false
        }
        else {
          SupplierDropDownDisable.value = false;
          RoundOffDisable.value = false
        }

      } else {
        SupplierDropDownDisable.value = IsGRNApproval.value.IsApproval == 1 ? false : true;
        RoundOffDisable.value = IsGRNApproval.value.IsApproval == 1 ? false : true
      }

    }


    function SupplierValue(data) {
      debugger;
      commonItemProps.value.supplierId = data.SupplierId;
      commonItemProps.value.SupllierStateId = data.StateId;

      if (EditId.value == undefined || EditId.value == 0) {
        items.value.length = 0;
        // AmountCalculation([], {}, 0), taxCalculation({}), GRNOverallAmountCal()
      }
    }

    let ItemDataTotalValue = reactive({
      totaltaxamount: 0.0,
      totaldiscountamount: 0.0,
      totalgrossamount: 0.0,
      totaltransportcharges: 0.0,
      totalservicecharges: 0.0,
      totalothercharges: 0.0,
      netamount: 0.0,
      totalqty: 0.0,
      totalrate: 0.0,
      grossamount: 0.0,
    });

    function poQtyToQty(data) {
      data.PoQty = data.ItemQuantity;
    }


    async function AmountCalculation(data, datalist, type) {

    }

    const ParameterValues = ref({ Id: 0, BranchId: 0, HospitalId: 0 });
    const PrintType = ref({ Type: "S", FormId: 2, ModuleId: 3 });

    function PrintCrystalReport(Id) {
      debugger;
      CrystalReportPopup.value = true;
      ParameterValues.value.Id = Id;
      ParameterValues.value.BranchId = Number(routes.query.BranchId);
      ParameterValues.value.HospitalId = HospitalId;

    }

    //GRN Trasport charges,other charges,discount overall calc
    function GRNOverallAmountCal() {
      debugger;
    }

    //Load GRN Return Autocomplete
    async function LoadGRNReturn() {
      debugger
      let PurSuopplierId = PurchaseformData.value.SupplierId;
      if (PurSuopplierId == 0) {
        toast.add({
          severity: "warn",
          summary: "Supplier Required",
          detail: "Please select a supplier before proceeding.",
          life: 3000,
        });
      }
      try {
        var response = await listserviceOut.GetListByDocNoCustom(
          DataObj.value.ReturnId,
          StoreId,
          12,
        );
        debugger;
        DataObj.value.ReturnOptions = response["result"]
          .filter((i1) => i1.ReturnType == 1 && i1.SupplierId == PurSuopplierId)
          .map((item: any) => {
            item.label = item.DocNo;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }

    //Get By Grn Return Id
    async function GetByGrn(data: any) {
      try {
        if (data.value.Id) {
          debugger;
          //const GRNReturn = data.value.Id ? data.value.Id : data.value;
          var Detailslist = await listserviceOut.GetById(data.value.Id);
          console.log(Detailslist);
          commonItemProps.value.type = 1;
          commonItemProps.value.fieldType = 1;
          showFields.value.RequestedQty.show = true;
          PurchaseformData.value.SupplierId = Detailslist["result"][0].SupplierId;

          recieveditems.value = Detailslist["result"].map((item) => {
            item.OrgItemsQty = Number(item.ItemQuantity);
            item.RequestedQty = Number(item.ItemQuantity);
            item.IssuedQty = item.RequestedQty;
            item.ItemQty1 = item.ItemQuantity;
            item.ItemQuantity = item.ItemQuantity - Number(item.ReturnsQty);
            item.BatchNo = '';
            item.ExpiryDate = '';
            // item.ExpiryDate1 = "";
            item.ManufactureDate = '';
            return item;
          }).filter((item) => {
            return item.ItemQuantity !== 0;
          });

          ListSelect.value = JSON.parse(JSON.stringify(recieveditems.value))
          itemcatfilteroptions.value = ListSelect.value.reduce((acc: any, current) => {
            const { CategoryId, ItemCategory1 }: any = current;
            const existingCategory: any = acc.find(item => item["value"] == CategoryId);
            if (existingCategory) {
              existingCategory.count++;
            } else {
              acc.push({ value: CategoryId, name: ItemCategory1 });
            }
            return acc;
          }, []);
          requestForm.value.RefId = data.value.Id;
          requestForm.value.RefNo = data.value.DocNo;
          requestForm.value.SupplierId = Detailslist["result"][0].SupplierId;
          for (let i = 0; i < recieveditems.value.length; i++) {
            recieveditems.value[i].PoQty = recieveditems.value[i].ItemQuantity;
            recieveditems.value[i].grossamount = 0;
          }

          requestForm.value.GRNTransportationCharges =
            data.value.TransportCharges || 0;
          requestForm.value.GRNOtherCharges = data.value.OtherCharges || 0;
          requestForm.value.GRNDiscount = data.value.DiscountAmount || 0;

          recieveditemsOrg.value = await recieveditems.value.map((item1) => {
            item1.ItemQty1 = item1.ItemQuantity;
            item1.ManufactureDt = item1.DocType == '19' ? item1.ManufactureDt : ""
            item1.ExpiryDate1 = item1.DocType == '19' ? item1.ExpiryDate1 : ""

            return item1
          })

        }
        else {
          debugger;
          //const GRNReturn = data.value.Id ? data.value.Id : data.value;
          var Detailslist = await listserviceOut.GetById(data.value);
          console.log(Detailslist);
          commonItemProps.value.type = 1;
          commonItemProps.value.fieldType = 1;
          showFields.value.RequestedQty.show = true;
          PurchaseformData.value.SupplierId = Detailslist["result"][0].SupplierId;

          recieveditems.value = Detailslist["result"].map((item) => {
            item.OrgItemsQty = Number(item.ItemQuantity);
            item.RequestedQty = Number(item.ItemQuantity);
            item.IssuedQty = item.RequestedQty;
            item.ItemQty1 = item.ItemQuantity;
            item.ItemQuantity = item.ItemQuantity - Number(item.ReturnsQty);
            item.BatchNo = '';
            item.ExpiryDate = '';
            // item.ExpiryDate1 = "";
            item.ManufactureDate = '';
            return item;
          }).filter((item) => {
            return item.ItemQuantity !== 0;
          });

          ListSelect.value = JSON.parse(JSON.stringify(recieveditems.value))
          itemcatfilteroptions.value = ListSelect.value.reduce((acc: any, current) => {
            const { CategoryId, ItemCategory1 }: any = current;
            const existingCategory: any = acc.find(item => item["value"] == CategoryId);
            if (existingCategory) {
              existingCategory.count++;
            } else {
              acc.push({ value: CategoryId, name: ItemCategory1 });
            }
            return acc;
          }, []);
          requestForm.value.RefId = data.Id;
          requestForm.value.RefNo = data.DocNo;
          requestForm.value.SupplierId = Detailslist["result"][0].SupplierId;
          for (let i = 0; i < recieveditems.value.length; i++) {
            recieveditems.value[i].PoQty = recieveditems.value[i].ItemQuantity;
            recieveditems.value[i].grossamount = 0;
          }

          requestForm.value.GRNTransportationCharges =
            data.TransportCharges || 0;
          requestForm.value.GRNOtherCharges = data.OtherCharges || 0;
          requestForm.value.GRNDiscount = data.DiscountAmount || 0;

          recieveditemsOrg.value = await recieveditems.value.map((item1) => {
            item1.ItemQty1 = item1.ItemQuantity;
            item1.ManufactureDt = item1.DocType == '19' ? item1.ManufactureDt : ""
            item1.ExpiryDate1 = item1.DocType == '19' ? item1.ExpiryDate1 : ""

            return item1
          })
        }

        // recieveditemsOrg.value = await recieveditems.value.map((item1) => {
        //   item1.ItemQty1 = item1.ItemQuantity;
        //   item1.ManufactureDt = item1.DocType == '19' ? item1.ManufactureDt : ""
        //   item1.ExpiryDate1 = paramnames == "DC" && requestForm.value.DCType == 2 && item1.DocType == '12' ? null : item1.ExpiryDate1

        //   return item1
        // })

      } catch (error) {
        console.log(error);
      }
    }

    let SelectedDCType = ref(0);
    function DCChange() {
      items.value = [];
      DataObj.value.ReturnId = "";
      requestForm.value.RefId = 0;
      SelectedDCType.value = requestForm.value.DCType;
    }

    function getColorStyle(data) {
      return data.ColdChain ? { color: "Orange" } : {};
    }

    function getPromoColorStyle(data) {
      return data.IsFreeItem ? { color: "Red" } : {};
    }

    function getFreeQtyColorStyle(data) {
      return data.IsFreeQtyItem ? { color: "green" } : {};
    }

    const stepslist = ref([
      { label: 'Received Items', value: '1' },
      { label: 'Item Allocation', value: '2' },
    ]);

    const goToStep = (index: number) => {
      if (tabMove.value == true) {
        currentStep.value = index;
      }
    };

    let receivedtabflag = ref(false)
    function TabClick(data) {
      if (data == 1) {
        TabsActive.value.AllItem = true;
        TabsActive.value.ReceivedItems = false;
      }
      else {
        TabsActive.value.AllItem = false;
        TabsActive.value.ReceivedItems = true;
        receivedtabflag.value = !receivedtabflag.value
      }
    }

    // async function SubmitItemAllocation() {
    const SubmitItemAllocation = handleSubmit(async (values) => {
      try {
        loading.value = true;
        BarCodeItem.value = BarCodeItem.value.filter((x) => x.DCItem == 0).map((i2) => {
          i2.RoomId = i2.RoomId ?? 0;
          i2.RackId = i2.RackId ?? 0;
          i2.RowId = i2.RowId ?? 0;
          i2.BoxId = i2.BoxId ?? 0;
          i2.BarCode = i2.BarCode ?? '';
          i2.ModifiedBy = i2.ModifiedBy ?? 0;
          i2.ModifiedAt = i2.ModifiedAt ?? moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          return i2;
        });

        let result = await StockInService.CreateBarCodeMapping(BarCodeItem.value);
        let msgMapping = result["ErrorInfo"].ErrorCode;
        if (msgMapping == null) {
          loading.value = false;
          if (IsGRNApproval.value.IsApproval == 0) {

            PrintCrystalReport(EditId.value);
            popup.value.successpop = true;
          }
        }
      }
      catch (error) {
        loading.value = false;
        console.log(error);
      }
    }
    )

    function AddItemAllocation(data) {
      BarCodeItem.value = data
    }

    function RoundOffOnChange() {
      debugger;

      let roundOffValue = Number(requestForm.value.RoundOff) || 0.00;

      // Check if RoundOff is out of the allowed range (-5 to 5)
      if (roundOffValue > 1 || roundOffValue < -1) {
        toast.add({
          severity: "warn",
          summary: "Invalid RoundOff Value",
          detail: "RoundOff should be between ₹-1 to ₹1.",
          life: 3000,
        });

        // Reset RoundOff input if invalid
        requestForm.value.RoundOff = "0.00";
        grossvalues.value.netamount = (
          Number(grossvalues.value.grossamount) -
          Number(grossvalues.value.totaldiscountamount || 0.00) +
          Number(grossvalues.value.taxamount) +
          Number(grossvalues.value.transportcharges || 0.00) +
          Number(grossvalues.value.freightcharges || 0.00) +
          Number(grossvalues.value.servicecharges || 0.00) +
          Number(grossvalues.value.othercharges || 0.00)
        ).toFixed(2);
        return; // Stop execution if RoundOff is out of range
      }

      // Calculate net amount including round off (positive adds, negative subtracts)
      let calculatedNetAmount = (
        Number(grossvalues.value.grossamount) -
        Number(grossvalues.value.totaldiscountamount || 0.00) +
        Number(grossvalues.value.taxamount) +
        Number(grossvalues.value.transportcharges || 0.00) +
        Number(grossvalues.value.freightcharges || 0.00) +
        Number(grossvalues.value.servicecharges || 0.00) +
        Number(grossvalues.value.othercharges || 0.00) +
        roundOffValue
      ).toFixed(2);

      grossvalues.value.netamount = calculatedNetAmount;

    }


    async function ExcelDataImport(ExcelData: any) {
      debugger;
      ExcelResponse.value = ExcelData;
      const slotFieldMapping: { [key: string]: string } = {
        Qty: 'ItemQuantity',
        FreeQty: 'FreeQty',
        transportcharges: 'transportcharges',
        Discount: 'Discount',
        servicecharges: 'servicecharges',
        othercharges: 'othercharges',
        BatchNo: 'BatchNo',
        ExpiryDate: 'ExpiryDate'
      };

      const mappedData = ExcelResponse.value.map((item: any) => {
        const mappedItem: { [key: string]: any } = {};
        Object.entries(item).forEach(([key, value]) => {
          const normalizeString = (str: string) => str.replace(/\s/g, '').toLowerCase();
          const header = headers.value.find(header => normalizeString(header.header) === normalizeString(key));

          if (header) {
            // Use the slot if it exists, otherwise use the field
            const field = header.field || (header.slot && slotFieldMapping[header.slot]);
            if (field) {
              mappedItem[field] = value;
            }
          }
        });
        return mappedItem;
      });


      let ItemProductIds: any = [];
      for (let i = 0; i < mappedData.length; i++) {
        let ItemProductId = mappedData[i].ItemProductId;
        if (mappedData[i]["ItemProductId"] != 0) {
          ItemProductIds.push(mappedData[i]["ItemProductId"]);
        }
      }

      let joinedItemProductIds = ItemProductIds.join(',');

      const result = await Itemservice.GetByMultipleProductId(
        joinedItemProductIds, HospitalId
      );


      Object.values(result["result"]).forEach((r: any) => {
        Object.values(mappedData).forEach((m: any) => {

          if (r.ItemProductId == m.ItemProductId) {
            m.Id = 0;
            m.ItemId = r.Id;
            m.PoQty = m.ItemQuantity;
            m.PackSizeId = r.PackSizeId;
            m.PackSizeQty = r.PackSizeQty;
            m.HSNId = r.HSNId;
            m.SalesPercentage = 0;
            m.Salestaxamount = "0.00";
            m.Brand = 0;
            m.ModelNumber = 0;
            m.Size = 0;
            m.TransportCharges = "0.00";
            m.BatchRequired = r.BatchRequired;
            m.ExpiryDtRequired = r.ExpiryDtRequired;
          }
        });
      });

      items.value = [...items.value, ...mappedData];

    }
    const maxDate = ref(new Date());

    const Itemschanges = (value) => {
      debugger;
      if (value != "") {
        items.value = []
        items.value = value;
      }
    };
    const handleChangedocument = async (event: Event) => {
      debugger;
      debugger;
      let result;
      let files: any = ''
      const input = event.target as HTMLInputElement;
      files = input['files'];
      console.log(files);
      if (files && files.length > 0) {
        debugger;
        for (let i = 0; i < files.length; i++) {
          let form = new FormData();
          console.log(files[i]);
          form.append("file", files[i]);
          console.log(form);
          result = await common.uploadquotation(form, 'TransactionFiles');
          console.log('Uploaded :', result);
          let ResponseValue = result;
          ResponseValue['Id'] = 0
          fullPath.value = result.uploadPath
          uploadedTableList.value.push(ResponseValue)
        }
      }
      debugger
      console.log(uploadedTableList.value)
    };
    function fileviewer(data) {
      debugger
      const newTabUrl = data;
      window.open(newTabUrl, '_blank');
    }

    const fileuploadDelete = async (data) => {
      DeletedFileUpload.push(data.Id)
      uploadedTableList.value = uploadedTableList.value.filter((item) => item.fileName != data.fileName)
      if (DeletedFileUpload.length > 0 && IsDraft == 1) {
        debugger
        let result = await StockInFileUploadServices.DeleteList(DeletedFileUpload.join(','));
      }
    }


    function DCNoDropdown(Value) {
      debugger;
      DCNoDropdownLength.value = Value;
    }

    // Create a date 5 days from today for minimum expiry date
    const minExpiryDate = computed(() => {
      const date = new Date();
      date.setDate(date.getDate() + 30);
      return date;
    });

    // // Computed property to group items by name and sum quantities
    // const summarizedItems = computed(() => {
    //   const itemMap = new Map();

    //   items.value.forEach(item => {
    //     const itemName = item.Itemname1;
    //     const quantity = Number(item.ItemQuantity) || 0;

    //     if (itemMap.has(itemName)) {
    //       itemMap.set(itemName, itemMap.get(itemName) + quantity);
    //     } else {
    //       itemMap.set(itemName, quantity);
    //     }
    //   });

    //   return Array.from(itemMap).map(([name, qty]) => ({
    //     name,
    //     qty
    //   }));
    // });

    // // Headers for the summary table
    // const summaryHeaders = computed(() => [
    //   {
    //     header: "Item Name",
    //     field: "name",
    //     sortable: true,
    //     class: "mediumwidth"
    //   },
    //   {
    //     header: "Qty",
    //     field: "qty",
    //     sortable: true,
    //     bodyclass: "right_td",
    //     class: "smallwidth"
    //   }
    // ]);
    const summarizedItems = computed(() => {
      const itemMap = new Map();

      items.value.forEach(item => {
        const itemName = item.Itemname1 || "Unnamed Item";
        const quantity = Number(item.ItemQuantity) || 0;

        const brand = item.BrandName || "-";
        const model = item.ModelNumberName || "-";
        const size = item.SizeName || "-";

        const key = `${itemName} | ${brand} / ${model} / ${size}`;

        if (itemMap.has(key)) {
          itemMap.set(key, itemMap.get(key) + quantity);
        } else {
          itemMap.set(key, quantity);
        }
      });

      return Array.from(itemMap).map(([fullName, qty]) => {
        const [name, brandModelSize] = fullName.split(" | ");
        return {
          name,
          brandModelSize,
          qty
        };
      });
    });

    const summaryHeaders = computed(() => [
      {
        header: "Item Name",
        field: "name",
        sortable: true,
        class: "mediumwidth"
      },
      {
        header: "Brand / Model / Size",
        field: "brandModelSize",
        sortable: false,
        class: "mediumwidth"
      },
      {
        header: "Qty",
        field: "qty",
        sortable: true,
        bodyclass: "right_td",
        class: "smallwidth"
      }
    ]);

    return {
      Itemschanges,
      maxDate,
      minExpiryDate,
      getPromoColorStyle,
      recieveditems,
      itemcatfilteroptions,
      FilterByCategory,
      AddItemAllocation,
      IsSubmitFunc,
      SubmitItemAllocation,
      BarCodeItem,
      TabClick,
      TabsActive,
      stepslist,
      currentStep,
      goToStep,
      // nextStep,
      getColorStyle,
      DCChange,
      GetByGrn,
      LoadGRNReturn,
      DataObj,
      paramnames,
      DCTypeOption,
      GRNOverallAmountCal,
      poQtyToQty,
      AmountCalculation,
      Entitydata,
      List,
      headers,
      paramValue,
      showFields,
      items,
      dataId,
      AddItems,
      dataItems,
      popup,
      closetrigger,
      IsSubmit,
      invDetails,
      // SupformData,
      requestForm,
      IsItemEdit,
      IsItemDelete,
      model,
      grossvalues,
      TotalGrossCalc,
      commonItemProps,
      getPoItems,
      itemDatas,
      nonFilterDatas,
      PurchaseformData,
      commonProps,
      RefIdByMas,
      taxvalues,
      SupplierValue,
      taxCalculation,
      SupplierDropDownDisable,
      overallTax,
      EditId,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      IsBatch,
      isScrolled,
      recieveditemsOrg,
      SelectList,
      AddselectedItem,
      AddAllItem,
      ListSelect,
      ExcelDataImport,
      hideFooter,
      TransportTaxOnChange,
      TransportAmountOnChange,
      FreightTaxOnChange,
      FreightAmountOnChange,
      OverallOtherChargesOnChange,
      OverAllDiscountAmountOnChange,
      RoundOffOnChange,
      ItemQtyOnChange,
      ItemDiscountPercentageCalculation,
      ItemDiscountAmountCalculation,
      ItemServiceChargesOnChange,
      ItemOtherChargesOnChange,
      clearItems,
      tabMove,
      handleChangedocument,
      uploadedTableList,
      fileviewer,
      fileuploadDelete,
      SelectedDCType,
      DCNoDropdown,
      DCNoDropdownLength,
      RoundOffDisable,
      loading,
      GRNCalculation,
      activetab,
      ItemDeleteConfirm,
      displayClass,
      IsCategoryFilter,
      normaltablesearch,
      getFreeQtyColorStyle,
      IsGRNApproval,
      IsDraft,
      showSummaryPopup,
      summarizedItems,
      summaryHeaders,
      receivedtabflag,
      ItemUnitRateOnChange
    };
  },
});
</script>
<style lang="scss">
.footer-sec-table {
  height: 100px;
}

// .stepperdiv {
//   align-items: center;
//   background-color: #e9e9e9;
//   position: sticky;
//   top: 0%;
//   transition: background-color 0.3s ease;
//   z-index: 100;
//   //padding: 10px;
//   padding: 7px;
// }

// .scrolled {
//   background-color: white;
// }

.stepslist {
  display: flex;
}

.singlestep {
  padding: 8px 5px;
  margin-right: 10px;
  cursor: pointer;
  font-weight: 600;
}

.singlestep span:first-child {
  border: 1px solid #000000;
  color: #444444;
  border-radius: 50%;
  padding: 9px;
  height: 25px;
  width: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  margin-right: 7px;
  font-weight: 700;
}

.singlestep.active span:first-child {
  border: 1px solid #3096FF;
  color: #3096FF;
}

.singlestep:first-child::before {
  border-bottom: 1px solid #e1e1e1;
}

.singlestep.active {
  color: #3096FF;
}

.steppercontent {
  margin-bottom: 10px;
}

.item-toggle {
  cursor: pointer;

  .btn-content {
    cursor: pointer !important;
  }
}

.item-toggle .link-txt {
  all: unset;
  float: right;
}

.item-toggle .link-txt:enabled:hover {
  all: unset;
  float: right;
}

.item-toggle .when-open {
  color: red;
  font-size: 14px;
}

.item-toggle .when-closed {
  color: #3096FF;
  font-size: 14px;
}

.grnitemstabs .nav-pills {
  // margin-bottom: 10px !important;
}

.grnitemstabs .nav-pills .nav-link {
  background: #FFFFFF !important;
  margin-left: 15px;
  border: 1px solid #999999;
  color: #999999;
  border-radius: 20px;
}

.grnitemstabs .nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  background: #0d6efd !important;
  color: #FFFFFF;
}

@media only screen and (max-width: 768px) {
  .footer-sec-table {
    height: auto;
  }
}

.free-item {
  color: palevioletred;
  /* Or any other styling you prefer */
}

.savedraftbtn {
  border: 1px solid #999999;
  padding: 10px 15px;
  width: max-content;
  border-radius: 5px;
  background-color: #ffffff;

  p {
    color: #999999;
  }
}

.poaction {
  display: flex;
  align-items: center;
  gap: 10px;

  .addbtn {
    padding: 14px 20px !important;
  }
}

/* Summary Content Styles */
.summary-content {
  max-height: 400px;
  overflow-y: auto;
  padding: 0 10px;
}


.summary-button {
  position: absolute !important;
  right: 10px;
  top: -40px;
  z-index: 5;
}
</style>
